<template>
  <Toast />
  <ConfirmDialog />
  <div v-if="cargandoComponente">
    <div class="grid" v-if="permitirVenta">
      <div class="col-12 md:col-8">
        <div class="card">
          <div class="p-fluid formgrid grid p-fondo">
            <div class="field col-12 md:col-6 mt-2">
              <span v-if="this.tipo_negocio != 2"><strong>BUSCAR CLIENTE | NOMBRE | CI/NIT:</strong></span>
              <span v-else><strong>BUSCAR POR PLACA | CLIENTE:</strong></span>
              <div class="p-inputgroup">
                <AutoComplete
                  field="nombre"
                  v-model="clienteSelect"
                  :suggestions="clientes"
                  :placeholder="tipo_negocio == 2 ? 'Buscar: ID, Placa o Cliente...' : 'Buscar: ID o Cliente...'"
                  @keyup.enter="buscarCliente($event)"
                  :loading="cargandoClientes"
                  :minLength="1"
                  autofocus
                  class="w-full p-fluid"
                  panelClass="surface-overlay shadow-3"
                >
                  <template #item="slotProps">
                    <div
                      v-if="tipo_negocio == 1"
                      class="p-1 border-bottom-1 surface-border hover:surface-hover cursor-pointer"
                    >
                      <div style="font-size: 1.1rem; color: #2c3e50">
                        <span v-if="mostrar_cod_cliente_en_venta" style="font-weight: 400"
                          >{{ slotProps.item.id }} -
                        </span>
                        <span style="font-weight: 700">{{ slotProps.item.nombre }}</span>
                        <span v-if="slotProps.item.ci_nit" style="font-weight: 400; color: #2c3e50">
                          - Nit: {{ slotProps.item.ci_nit }}
                        </span>
                      </div>
                    </div>

                    <div
                      v-else
                      class="flex align-items-center p-1 pl-2 border-bottom-1 surface-border hover:surface-hover cursor-pointer w-full"
                    >
                      <div class="mr-2 flex align-items-center">
                        <i class="pi pi-car text-orange-500" style="font-size: 1.3rem"></i>
                      </div>

                      <div class="flex-1 overflow-hidden">
                        <div class="flex align-items-center mb-1">
                          <span class="text-lg font-bold text-900 mr-2 font-monospace">
                            {{ slotProps.item.placa }}
                          </span>
                          <span class="text-sm text-600 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                            <i class="pi pi-user mr-1 text-400"></i>
                            {{ slotProps.item.nombre }}
                          </span>
                        </div>

                        <div class="flex align-items-center text-xs text-700 gap-2" style="margin-top: -2px">
                          <div class="flex align-items-center">
                            <i class="pi pi-tag mr-1 text-blue-500" style="font-size: 0.7rem"></i>
                            <span>{{ slotProps.item.marca }}</span>
                          </div>

                          <span class="text-300">|</span>

                          <div class="flex align-items-center">
                            <i class="pi pi-cog mr-1 text-green-500" style="font-size: 0.7rem"></i>
                            <span>{{ slotProps.item.modelo || '-' }}</span>
                          </div>

                          <span class="text-300">|</span>

                          <div class="flex align-items-center">
                            <i class="pi pi-id-card mr-1 text-primary" style="font-size: 0.7rem"></i>
                            <span class="text-primary font-semibold">CÓDIGO: {{ slotProps.item.cliente_id }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template #empty>
                    <div class="p-2 text-center text-sm">
                      <span class="text-600">No hay resultados.</span>
                    </div>
                  </template>
                </AutoComplete>
                <Button
                  :icon="cargandoClientes ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
                  class="p-button-warning"
                  v-tooltip.top="'Buscar Cliente'"
                  @click="buscarCliente($event)"
                  :disabled="cargandoClientes"
                />
                <Button
                  v-if="'Cliente Crear' in auth.user.permissions && this.tipo_negocio != 2"
                  icon="pi pi-user-plus"
                  class="p-button-info"
                  v-tooltip.top="'Nuevo Cliente'"
                  @click="activarCliente"
                />

                <Button
                  v-if="'Vehiculos Crear' in auth.user.permissions && this.tipo_negocio == 2"
                  icon="pi pi-car"
                  class="p-button-info"
                  v-tooltip.top="'Nuevo Vehículo'"
                  @click="openModalVehiculo()"
                />
              </div>
              <div class="p-fluid formgrid mt-1 ml-2">
                <span
                  v-if="clienteSelect != null && clienteSelect.placa != null"
                  style="
                    font-size: 13px;
                    background-color: white;
                    border-radius: 2px;
                    border: 1px solid #ccc;
                    font-weight: bold;
                  "
                >
                  <span v-tooltip.top="'Placa'">{{ clienteSelect.placa }} - </span>
                  <span v-tooltip.top="'Marca'">{{ clienteSelect.marca }} - </span>
                  <span v-tooltip.top="'Modelo'">{{ clienteSelect.modelo }} </span>
                </span>
              </div>
              <div
                class="p-inputgroup mt-1"
                v-if="clienteSelect != null && clienteSelect.id != null && clienteSelect.tipo_cliente != 0"
              >
                <span>
                  <strong class="mr-1 text-900">TIPO CLIENTE:</strong>
                  <span class="p-tag p-tag-rounded p-tag-warning">
                    {{ clienteSelect.tipo_cliente == 1 ? 'Mayorista' : 'Normal' }}
                  </span>
                </span>
              </div>
            </div>
            <div class="field col-12 md:col-6 mt-2" v-if="facturar">
              <span><strong>CI/NIT:</strong></span>
              <div class="p-inputgroup">
                <AutoComplete
                  v-model="nitClienteSelect"
                  :suggestions="nitClientesFiltrados"
                  field="nombre"
                  placeholder="Buscar por NIT o Nombre"
                  v-tooltip.top="'Buscar Cliente por NIT o Nombre (mín 3 caracteres)'"
                  @keyup.enter="buscarClientePorNitConEnter"
                  @item-select="seleccionarClienteNit($event)"
                  :loading="cargandoNit"
                  :minLength="3"
                  :completeOnFocus="false"
                  :forceSelection="false"
                >
                  <template #item="slotProps">
                    <div class="flex align-items-center p-2">
                      <i class="pi pi-building mr-2" style="font-size: 1.3rem; color: #5dade2"></i>
                      <div class="flex-1">
                        <strong style="font-size: 1.1rem">{{ slotProps.item.nombre }}</strong>
                        <div class="text-sm text-secondary mt-1">
                          <span v-if="slotProps.item.tipo_documento === 5">
                            <strong>NIT:</strong>
                            <span class="nit-numero-destacado">{{ slotProps.item.ci_nit }}</span>
                            <span class="ml-2 p-tag p-tag-success p-tag-sm" style="background: #28a745; color: white">
                              NIT
                            </span>
                          </span>
                          <span v-else-if="slotProps.item.tipo_documento === 1">
                            <strong>CI:</strong>
                            <span class="nit-numero-destacado">{{ slotProps.item.ci_nit }}</span>
                            <span class="ml-2 p-tag p-tag-info p-tag-sm" style="background: #17a2b8; color: white">
                              CI
                            </span>
                          </span>
                          <span v-else>
                            <strong>DOC:</strong>
                            <span class="nit-numero-destacado">{{ slotProps.item.ci_nit }}</span>
                            <span class="ml-2 p-tag p-tag-secondary p-tag-sm">
                              {{ obtenerNombreTipoDocumento(slotProps.item.tipo_documento) }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>

                  <!-- Template #empty (mantén igual) -->
                  <template #empty>
                    <div class="p-3 text-center">
                      <i class="pi pi-info-circle mb-2" style="font-size: 2rem; color: #64748b"></i>
                      <p class="mb-2">
                        No se encontraron resultados
                        <span v-if="nitClienteSelect && nitClienteSelect.length >= 3">
                          para: <strong>"{{ nitClienteSelect }}"</strong>
                        </span>
                      </p>
                      <Button
                        v-if="nitClienteSelect && nitClienteSelect.length >= 3"
                        label="Registrar Nuevo Cliente"
                        icon="pi pi-plus"
                        class="p-button-sm p-button-success"
                        @click="activarClienteFactura"
                      />
                    </div>
                  </template>
                </AutoComplete>

                <Button
                  :icon="cargandoNit ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
                  class="p-button-warning"
                  v-tooltip.top="'Buscar con Enter'"
                  @click="buscarClientePorNitConEnter"
                  :disabled="!nitClienteSelect || nitClienteSelect.length < 3"
                />

                <Button
                  v-if="'Cliente Crear' in auth.user.permissions"
                  icon="pi pi-id-card"
                  class="p-button-info"
                  v-tooltip.top="'Registrar NIT'"
                  @click="activarClienteFactura"
                />
              </div>

              <div v-if="razon_social" class="p-2" style="background: #f0f8ff; border-radius: 2px; margin-top: 2px">
                <small style="color: #5dade2; font-weight: bold">RAZÓN SOCIAL:</small>
                <span style="margin-left: 5px; color: #2c3e50; font-weight: bold">{{
                  razon_social || 'Sin datos'
                }}</span>
              </div>
            </div>
            <div class="field col-12 md:col-6 mt-2" v-if="!facturar">
              <span><strong>RAZ&Oacute;N SOCIAL:</strong></span>
              <div class="p-inputgroup">
                <Textarea v-model="razon_social" rows="1" autoResize placeholder="Razón Social" readonly></Textarea>
              </div>
            </div>
          </div>
          <div class="p-fluid formgrid grid mt-2 mb-3">
            <div class="field col-12 md:col-5 mb-0" v-if="'Venta ConMedico' in auth.user.permissions">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <span v-if="this.tipo_negocio == 2"><strong>TRABAJADOR:</strong></span>
                  <span v-else><strong>TRABAJADOR.:</strong></span>
                  <Checkbox v-model="medico_referencia" :binary="true" class="ml-0 mr-0" v-tooltip.top="'Trabajador'" />
                </span>
                <Dropdown
                  v-if="medico_referencia == true"
                  v-model="medicoSelected"
                  :options="medicos"
                  placeholder="Seleccione..."
                  optionLabel="nombre_completo"
                  optionValue="id"
                  :filter="true"
                  :showClear="true"
                />
                <!-- v-show="medico_referencia && medicoSelected" -->
                <Button
                  v-if="false"
                  icon="pi pi-eye"
                  class="p-button-info"
                  v-tooltip.top="'Ver Trabajadores Asignados'"
                  @click="ver_medico_detalle = !ver_medico_detalle"
                />
              </div>
            </div>
            <div class="field col-12 md:col-5 mb-0" v-if="'Venta Membresia' in auth.user.permissions">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <span><strong>MEMBRESÍA:</strong></span>
                  <span v-if="tiene_membresia_activa && clienteSelect != null" class="membresia_activa"
                    >VÁLIDA: {{ formatDate(fecha_membresia_hasta ?? '-') }}</span
                  >
                  <span v-else-if="tiene_membresia_activa == false && clienteSelect" class="membresia_inactiva"
                    >INACTIVA</span
                  >
                </span>
              </div>
            </div>
            <div class="field col-12 md:col-4 mb-0" v-if="'Venta VenderPaquete' in auth.user.permissions">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <span v-if="vender_paquete != 'vender_paquete'"><strong>PAQUETE:</strong></span>
                  <Checkbox v-model="vender_paquete" value="vender_paquete" v-tooltip.top="'Vender Paquete'" />
                </span>
                <Dropdown
                  v-if="vender_paquete == 'vender_paquete'"
                  v-model="paqueteSelected"
                  :options="paqueteproductos"
                  placeholder="Paquete..."
                  optionLabel="nombre"
                  optionValue="id"
                  :filter="true"
                />
                <Button
                  :disabled="!paqueteSelected"
                  v-if="vender_paquete == 'vender_paquete'"
                  icon="pi pi-plus"
                  class="p-button-info"
                  v-tooltip.top="'Agregar Paquete al Detalle'"
                  @click="agregarProductosPaqueteAlDetalle"
                />
              </div>
            </div>
            <div class="field col-12 md:col-3 mb-0" v-if="'Proforma Crear' in auth.user.permissions">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <span v-if="!buscar_proforma"><strong>PROFORMA:</strong></span>
                  <Checkbox v-model="buscar_proforma" :binary="true" v-tooltip.top="'Buscar Proforma'" />
                </span>
                <InputText
                  v-if="buscar_proforma"
                  v-model="proforma_codigo"
                  placeholder="Código Proforma"
                  @keyup.enter="agregarProductosProforma"
                />
                <Button
                  :disabled="!proforma_codigo"
                  v-if="buscar_proforma"
                  icon="pi pi-search"
                  class="p-button-info"
                  v-tooltip.top="'Buscar Proforma'"
                  @click="agregarProductosProforma"
                />
              </div>
            </div>
          </div>
          <div v-if="vieneDeProforma" class="w-full">
            <hr />
            <div class="p-3 mb-3" style="background: #dbeafe; border-left: 4px solid #3b82f6; border-radius: 4px">
              <div class="flex align-items-center justify-content-between">
                <div>
                  <i class="pi pi-info-circle mr-2" style="color: #3b82f6"></i>
                  <strong>Convirtiendo Proforma #{{ proforma_codigo }} a Venta</strong>
                </div>
                <Button
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-sm"
                  @click="limpiarProforma()"
                />
              </div>
            </div>
            <hr />
          </div>
          <div v-if="vieneDeAgenda" class="w-full">
            <hr />
            <div class="p-3 mb-3" style="background: #fef9c3; border-left: 4px solid #f59e0b; border-radius: 4px">
              <div class="flex align-items-center justify-content-between">
                <div>
                  <i class="pi pi-calendar mr-2" style="color: #f59e0b"></i>
                  <strong>Cobrando reserva: {{ agenda_reserva?.nombre_cliente }}</strong>
                  <span class="ml-2 text-sm text-600" v-if="agenda_reserva?.nombre_producto">
                    · {{ agenda_reserva.nombre_producto }}
                  </span>
                  <span class="ml-2 text-sm" style="color: #f59e0b" v-if="agenda_reserva?.anticipo > 0">
                    · Anticipo pagado: {{ agenda_reserva.anticipo }} Bs
                  </span>
                </div>
                <Button
                  icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-sm"
                  @click="limpiarAgenda()"
                />
              </div>
            </div>
            <hr />
          </div>
          <hr />
          <div class="p-fluid formgrid grid mb-2" v-if="vender_con_codigo_barra">
            <div class="field col-12 md:col-3 mb-0">
              <div class="p-inputgroup">
                <InputText
                  v-model="codigo_barra"
                  placeholder="Código de Barra"
                  @keyup.enter="buscarProductoPorCodigoBarra"
                />
                <Button
                  :disabled="!codigo_barra"
                  icon="pi pi-search"
                  class="p-button-warning"
                  @click="buscarProductoPorCodigoBarra"
                />
              </div>
            </div>
          </div>

          <div class="p-fluid formgrid grid mb-3">
            <div class="field col-12 md:col-3 mb-0" v-if="vender_con_caso_uso">
              <InputText v-model="caso_uso" placeholder="Caso de Uso" @keyup.enter="buscarProducto($event)" />
            </div>

            <div :class="vender_con_caso_uso ? 'field col-12 md:col-9 mb-0' : 'field col-12 md:col-12 mb-0'">
              <div class="p-inputgroup">
                <AutoComplete
                  v-model="productoSelecionado"
                  :suggestions="productosListadoFiltrado"
                  @keyup.enter="buscarProducto($event)"
                  @complete="manejadorBusquedaProducto($event)"
                  placeholder="BUSCAR PRODUCTO/SERVICIO"
                  class="w-full"
                  :pt="{
                    input: {
                      style: 'font-weight: 600; font-size: 1.05rem; padding: 0.75rem;'
                    }
                  }"
                >
                  <template #item="slotProps">
                    <div
                      class="flex align-options-center item-producto-responsive"
                      :class="{
                        'bg-gray-400':
                          (slotProps.item.stock.length > 0 ? sinDecimal(slotProps.item.stock[0].cantidad) : 0) == 0
                      }"
                    >
                      <!-- CÓDIGO -->
                      <div
                        class="text-overflow-ellipsis overflow-hidden p-0 col-codigo"
                        :class="computedBuscarProductoPorSelected ? 'col-5' : 'col-2'"
                        :title="slotProps.item.codigo_origen"
                        v-if="mostrar_codigo_interno"
                      >
                        <span class="mobile-label">COD:</span>
                        {{ slotProps.item.codigo_interno }}
                      </div>

                      <!-- PRODUCTO -->
                      <div
                        class="text-overflow-ellipsis overflow-hidden p-0 col-producto"
                        :class="computedBuscarProductoPorSelected ? 'col-5' : 'col-7'"
                        v-tooltip.top="slotProps.item.descripcion"
                      >
                        <span class="mobile-label">PRODUCTO:</span>
                        <span class="producto-nombre">{{ slotProps.item.descripcion.substring(0, 100) }}</span>

                        <!-- MARCA en mobile - con fondo plomito -->
                        <span
                          class="producto-marca-mobile"
                          v-if="
                            slotProps.item.fabrica_nombre &&
                            slotProps.item.fabrica_nombre.toUpperCase() !== 'NO DEFINIDO'
                          "
                        >
                          - {{ slotProps.item.fabrica_nombre }}
                        </span>
                      </div>

                      <!-- MARCA (solo desktop) -->
                      <div
                        class="col-2 col-marca text-overflow-ellipsis overflow-hidden p-0 text-center"
                        :title="slotProps.item.fabrica_nombre"
                        style="font-weight: bold"
                        v-if="
                          slotProps.item.fabrica_nombre && slotProps.item.fabrica_nombre.toUpperCase() !== 'NO DEFINIDO'
                        "
                      >
                        <span class="mobile-label">MARCA:</span>
                        {{ slotProps.item.fabrica_nombre }}
                      </div>

                      <!-- CASO DE USO -->
                      <div
                        class="col-2 col-caso p-0 mr-1 text-overflow-ellipsis overflow-hidden"
                        style="background-color: aqua; border-radius: 2px"
                        v-if="
                          computedBuscarProductoPorSelected &&
                          slotProps.item.caso_uso != null &&
                          slotProps.item.caso_uso != ''
                        "
                        v-tooltip.top="slotProps.item.caso_uso"
                      >
                        <span class="mobile-label">CASO:</span>
                        {{ slotProps.item.caso_uso.substring(0, 15) }}...
                      </div>

                      <!-- STOCK -->
                      <div
                        v-if="slotProps.item.tipo_catalogo == 1"
                        class="col-1 col-stock flex align-items-center justify-content-center p-0 mr-1"
                        :class="
                          stockClass(slotProps.item.stock.length > 0 ? sinDecimal(slotProps.item.stock[0].cantidad) : 0)
                        "
                      >
                        <span class="mobile-label">STOCK:</span>
                        <strong>{{
                          slotProps.item.stock.length > 0
                            ? stock_decimales
                              ? parseFloat(slotProps.item.stock[0].cantidad)
                              : sinDecimal(slotProps.item.stock[0].cantidad)
                            : 0
                        }}</strong>
                      </div>

                      <!-- PRECIO -->
                      <div
                        class="col-2 col-precio flex align-items-center justify-content-center p-0"
                        style="font-size: 13px; color: #ffffff; background-color: rgb(244, 67, 54); border-radius: 2px"
                        v-tooltip.top="
                          mostrar_cif
                            ? 'Precio CIF=' +
                              slotProps.item.precio_compra +
                              '\n Precio FOB=' +
                              slotProps.item.precio_cif
                            : ''
                        "
                      >
                        <span class="mobile-label">PRECIO:</span>
                        <strong>
                          <span class="desktop-only">Bs. </span>{{ obtenerPrecioMostrar(slotProps.item) }}
                        </strong>
                      </div>
                    </div>
                  </template>
                </AutoComplete>

                <Button
                  :disabled="!productoSelecionado || cargandoProductos"
                  :icon="cargandoProductos ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
                  class="p-button-warning"
                  v-tooltip.top="'Buscar'"
                  @click="buscarProducto($event)"
                />

                <Button
                  icon="pi pi-bars"
                  class="p-button-info"
                  v-tooltip.top="'Ver Resultados'"
                  :disabled="productosListadoFiltrado.length == 0"
                  @click="activarModalProductosFiltrados"
                />

                <Button
                  :icon="panelColapsado ? 'pi pi-chevron-down' : 'pi pi-chevron-up'"
                  class="p-button-secondary"
                  v-tooltip.top="panelColapsado ? 'Mostrar Filtros' : 'Ocultar Filtros'"
                  @click="togglePanelMasFiltros"
                />
              </div>
            </div>

            <div v-show="panelColapsado" class="col-12 mt-0 mb-0 border-round border-1 surface-border p-3">
              <div class="grid">
                <div class="field col-12 md:col-5 mb-2">
                  <Dropdown
                    v-model="grupoSelected"
                    :options="grupos"
                    optionLabel="nombre"
                    optionValue="id"
                    :filter="true"
                    :showClear="true"
                    placeholder="Seleccionar Grupo..."
                    class="w-full"
                  />
                </div>

                <div class="field col-12 md:col-5 mb-2">
                  <AutoComplete
                    :dropdown="true"
                    field="nombre"
                    v-model="laboratorioSelected"
                    :suggestions="laboratoriosListadoFiltrado"
                    @complete="buscarLaboratorio($event)"
                    placeholder="Buscar Marca"
                    class="w-full"
                  >
                    <template #item="slotProps">
                      <div>{{ slotProps.item.nombre }}</div>
                    </template>
                  </AutoComplete>
                </div>

                <div class="field col-12 md:col-2 mb-2">
                  <Button
                    label="Limpiar"
                    icon="pi pi-filter-slash"
                    class="p-button-secondary p-button-outlined w-full"
                    @click="limpiarFiltrosBusquedaProducto"
                  />
                </div>

                <div class="field col-12 mb-0">
                  <div class="flex flex-wrap justify-content-center gap-2">
                    <div
                      v-for="filtro of listaFiltrosVisual"
                      :key="filtro.value"
                      class="flex align-items-center"
                      style="background: white; padding: 0.3rem 0.6rem; border-radius: 4px; border: 1px solid #e5e7eb"
                    >
                      <Checkbox
                        v-model="buscarProductoPorSelected"
                        :inputId="filtro.value"
                        name="filtro"
                        :value="filtro.value"
                      />
                      <label
                        class="ml-2 mb-0"
                        style="font-size: 11px; font-weight: 600; cursor: pointer"
                        :for="filtro.value"
                      >
                        {{ filtro.label }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <DataTable
            ref="dt_venta_detalle"
            class="p-datatable-sm mt-2"
            dataKey="id"
            :value="productosVentas"
            responsiveLayout="scroll"
            scrollHeight="400px"
            editMode="cell"
            @cell-edit-complete="guardandoCambiosCelda"
            :rowhover="true"
            stripedRows
            showGridlines
            selectionMode="single click"
            :rowClass="rowClassDetalle"
          >
            <template #empty>
              <span
                class="flex align-items-center justify-content-center"
                style="background-color: #f8d7da; padding: 5px; border-radius: 5px; color: #721c24"
                >Busca Productos para agregar al Detalle!</span
              ></template
            >
            <Column header="#">
              <template #body="slotProps">
                {{ 1 + slotProps.index }}
              </template>
            </Column>
            <Column header="COD.INT." v-if="mostrar_codigo_interno">
              <template #body="{ data }">
                {{ data.codigo_interno }}
              </template>
            </Column>
            <Column field="nombre_producto" header="DESCRIPCIÓN/PRODUCTO">
              <template #body="{ data }">
                <span>
                  <strong>{{ data.nombre_producto }}</strong
                  ><strong> ** </strong>
                  <span v-if="data.nombre_fabrica != null">
                    {{ data.nombre_fabrica }}
                  </span>
                  <span v-else-if="data.fabrica_nombre != null">
                    {{ data.fabrica_nombre }}
                  </span>
                  <span v-else>{{ data.producto.fabrica_nombre != null ? data.producto.fabrica_nombre : '' }}</span>
                </span>
              </template>
            </Column>
            <Column class="text-center strong" field="cantidad" header="STOCK">
              <template #body="{ data }">
                <span v-if="data.tipo_catalogo === 1" :class="claseEstado(data)">
                  <strong> {{ parseFloat(data.cantidad) }}</strong>
                </span>
                <span v-else>-</span>
              </template>
            </Column>
            <Column
              v-if="stock_decimales"
              class="text-center strong bg-green-200"
              field="cantidad_venta"
              header="CANTIDAD"
              style="font-weight: bold; font-size: 14px; color: black"
            >
              <template #body="slotProps">
                {{ slotProps.data.cantidad_venta }}
              </template>
              <template #editor="{ data, field }">
                <InputNumber
                  v-model="data[field]"
                  :min="1"
                  locale="de-DE"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  mode="decimal"
                />
              </template>
            </Column>
            <Column
              v-else
              class="text-right strong bg-green-200"
              field="cantidad_venta"
              header="CANTIDAD"
              style="font-weight: bold; color: black"
            >
              <template #body="slotProps">
                {{ slotProps.data.cantidad_venta }}
              </template>
              <template #editor="{ data, field }">
                <InputNumber v-model="data[field]" :min="1" locale="de-DE" />
              </template>
            </Column>
            <Column class="text-right strong" field="ultimo_precio" header="PRECIO" style="font-weight: bold">
              <template #body="slotProps">
                {{ convertirNumeroGermanicFormat(slotProps.data.ultimo_precio) }}
              </template>
              <template #editor="{ data, field }" v-if="'Venta EditarPrecio' in this.auth.user.permissions">
                <InputNumber
                  v-model="data[field]"
                  :inputClass="'text-right'"
                  :min="0"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  locale="de-DE"
                />
              </template>
            </Column>
            <Column
              v-if="aplica_descuento"
              class="flex-row-reverse strong bg-green-200"
              field="descuento_neto"
              header="DESC."
              style="font-weight: bold; color: black"
            >
              <template #body="slotProps">
                {{ convertirNumeroGermanicFormat(slotProps.data.descuento_neto) }}
              </template>
              <template #editor="slotProps">
                <InputNumber
                  :inputClass="'text-right'"
                  :min="0"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  locale="de-DE"
                  v-model="slotProps.data.descuento_neto"
                />
              </template>
            </Column>
            <Column class="text-right" field="total" header="TOTAL" style="font-weight: bold">
              <template #body="slotProps">
                {{
                  slotProps.data.ultimo_precio > 0
                    ? convertirNumeroGermanicFormat(
                        slotProps.data.ultimo_precio * slotProps.data.cantidad_venta - slotProps.data.descuento_neto
                      )
                    : convertirNumeroGermanicFormat(0)
                }}
              </template>
            </Column>
            <Column v-if="ver_medico_detalle" field="medico_id" header="TRABAJADOR/A" style="font-weight: bold">
              <template #body="slotProps">
                {{ slotProps.data.nombre_medico || '' }}
              </template>
              <template #editor="slotProps">
                <Dropdown
                  v-model="slotProps.data.medico_id"
                  :options="medicos"
                  optionLabel="nombre_completo"
                  optionValue="id"
                  placeholder="Seleccione un Trabajador/a"
                  @change="onMedicoChange($event, slotProps)"
                />
              </template>
            </Column>
            <Column class="strong">
              <template #header>
                <i class="pi pi-trash"></i>
              </template>
              <template #body="slotProps">
                <Button
                  @click="quitarProductoDetalle(slotProps)"
                  v-tooltip.top="'Quitar Producto'"
                  icon="pi pi-times"
                  class="p-button-rounded p-button-danger p-button-text"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <div class="col-12 md:col-4">
        <div class="card">
          <div class="p-fluid formgrid grid" v-if="mostrar_fecha_venta">
            <table class="field col-12 md:col-12">
              <tr>
                <td>
                  <strong>FECHA DE VENTA:</strong>
                  <Checkbox
                    v-model="venta_fecha_diferente"
                    :binary="true"
                    v-tooltip.top="'Vender con fecha de venta diferente'"
                  />
                </td>
                <td v-if="venta_fecha_diferente">
                  <InputText
                    v-model="fecha_venta"
                    type="date"
                    class="p-inputtext-sm"
                    :max="new Date().toISOString().split('T')[0]"
                  />
                </td>
              </tr>
            </table>
          </div>
          <span style="font-size: 18px; font-weight: bold"> TOTALES DE VENTA:</span>
          <div class="p-fluid formgrid grid">
            <table class="field col-12 md:col-12">
              <tr>
                <td>
                  <strong>SUB TOTAL:</strong>
                </td>
                <td class="text-right">{{ convertirNumeroGermanicFormat(subtotal) }} Bs.</td>
              </tr>
              <tr v-if="aplica_descuento">
                <td>
                  <strong>DESCUENTO:</strong>
                </td>
                <td class="text-right">{{ convertirNumeroGermanicFormat(descuento) }} Bs.</td>
              </tr>
              <tr v-if="venta_credito">
                <td>
                  <strong>Interes:</strong>
                </td>
                <td class="text-right">
                  {{ convertirNumeroGermanicFormat(monto_venta_a_credito_interes) }}
                  Bs.
                </td>
              </tr>
              <tr>
                <td>
                  <h4><strong>TOTAL VENTA:</strong></h4>
                </td>
                <td v-if="!venta_credito" class="text-right">
                  <h2>{{ convertirNumeroGermanicFormat(total_venta) }} Bs.</h2>
                </td>
                <td v-else>
                  <h2>
                    {{ convertirNumeroGermanicFormat(total_venta + monto_venta_a_credito_interes) }}
                    Bs.
                  </h2>
                </td>
              </tr>
              <tr v-if="tipo_pagoSelect == 2">
                <td>
                  <strong>A CUENTA:</strong>
                </td>
                <td class="text-right">
                  {{ convertirNumeroGermanicFormat(a_cuenta + monto_pago) }}
                  Bs.
                </td>
              </tr>
              <tr v-if="tipo_pagoSelect == 2">
                <td>
                  <strong>SALDO:</strong>
                </td>
                <td v-if="!venta_credito" class="text-right">
                  {{ convertirNumeroGermanicFormat(total_venta - a_cuenta - monto_pago) }}
                  Bs.
                </td>
                <td v-else class="text-right">
                  {{
                    convertirNumeroGermanicFormat(total_venta - a_cuenta - monto_pago + monto_venta_a_credito_interes)
                  }}
                  Bs.
                </td>
              </tr>
            </table>
            <div class="field col-12 md:col-12" v-if="facturar && mostrar_actividad_economica">
              <span><strong>ACTIVIDAD ECONOMICA:</strong></span>
              <div class="p-inputgroup">
                <Dropdown
                  id="actividad_economica"
                  v-model="actividad_economica_selected"
                  :options="actividades_economicas"
                  option-label="descripcion"
                  option-value="codigo"
                  placeholder="Seleccione una actividad economica"
                  @change="cambiarActividadEconomica"
                />
              </div>
            </div>
            <div class="p-field field col-12 md:col-12">
              <div class="p-inputgroup">
                <template v-if="'Venta Facturar' in auth.user.permissions">
                  <Checkbox
                    class="mr-1"
                    value="facturar"
                    v-model="facturar"
                    :binary="true"
                    v-tooltip.top="'Enviar'"
                  /><span class="p-tag p-tag-rounded p-tag-danger mr-3">ENVIAR</span>
                </template>
                <template v-if="'Venta FactIndicador' in auth.user.permissions">
                  <Checkbox
                    class="mr-1"
                    v-model="fact_indicador"
                    :binary="true"
                    v-tooltip.top="'Solo marcar como facturado'"
                    :disabled="total_venta == 0"
                  /><span class="p-tag p-tag-rounded p-tag-danger mr-3">ENVIAR</span>
                </template>
                <Checkbox
                  :class="'Venta Facturar' in auth.user.permissions == false ? 'mr-1' : 'ml-3 mr-1'"
                  v-model="aplica_descuento"
                  :binary="true"
                  v-tooltip.top="'Aplicar Descuento'"
                  :disabled="'Venta Descuentos' in auth.user.permissions == false || total_venta == 0"
                />
                <span class="p-tag p-tag-rounded p-tag-warning">DESCUENTO</span>
                <Checkbox class="mr-1 ml-2" v-tooltip.top="'Observación'" v-model="observacion_check" :binary="true" />
                <span class="p-tag p-tag-rounded p-tag-info">OBSERVACIÓN</span>
              </div>
            </div>
            <div class="field col-12 md:col-12" v-if="observacion_check">
              <Textarea v-model="observacion" rows="3" autoResize placeholder="Glosa/observación" />
            </div>
            <template v-if="aplica_descuento">
              <table class="field col-12 md:col-12">
                <tr v-if="grupos_id_selected != '' && grupos_id_selected != null && aplica_descuento">
                  <td>
                    <strong>DESC. ASIGNADOS:</strong>
                  </td>
                  <td
                    class="text-right"
                    style="background-color: #fbc02d; border-radius: 5px; padding: 1px; font-weight: bold"
                  >
                    {{ grupos_id_selected }}
                  </td>
                </tr>
                <tr v-show="true">
                  <td>
                    <strong>DESC. NETO :</strong>
                  </td>
                  <td class="text-right">
                    <InputNumber
                      v-model="descuento"
                      locale="de-DE"
                      input-class="text-right"
                      :min="0"
                      :max="subtotal"
                      :minFractionDigits="2"
                      :maxFractionDigits="2"
                      placeholder="descuento neto"
                      @keyup="calcular_agregar_des_total_venta"
                    />
                  </td>
                  <td class="text-right">
                    <Button
                      icon="pi pi-check"
                      class="p-button-outlined p-button-secondary"
                      v-tooltip.top="'Descuento neto'"
                      @click="calcular_agregar_des_total_venta"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>DESCUENTO %:</strong>
                  </td>
                  <td class="text-right strong">
                    <InputNumber
                      v-model="desc_venta_porcentaje"
                      locale="de-DE"
                      input-class="text-right"
                      :min="0"
                      :max="100"
                      :minFractionDigits="2"
                      :maxFractionDigits="2"
                      placeholder="descuento %"
                      @keyup="calcular_agregar_des_total_venta_porcentaje"
                    />
                  </td>
                  <td class="text-right">
                    <Button
                      v-tooltip.top="'Descuento %'"
                      icon="pi pi-check"
                      class="p-button-outlined p-button-secondary"
                      @click="calcular_agregar_des_total_venta_porcentaje"
                    />
                  </td>
                </tr>
              </table>
            </template>
            <div class="p-field field col-12 md:col-12">
              <div class="p-inputgroup">
                <template v-if="'Venta Credito' in auth.user.permissions">
                  <Checkbox
                    class="mr-1"
                    v-model="venta_credito"
                    :binary="true"
                    v-tooltip.top="'Venta a Crédito'"
                  ></Checkbox>
                  <span :class="'p-tag p-tag-rounded' + (total_venta == 0 ? ' bg-black-alpha-20' : ' p-tag-info')"
                    >A CRÉDITO</span
                  >
                </template>
                <template v-if="'Venta M.Pagos' in auth.user.permissions">
                  <Checkbox
                    :class="'Venta Credito' in auth.user.permissions == false ? 'mr-1' : 'ml-3 mr-1'"
                    value="metodo_pago_check"
                    v-model="metodo_pago_check"
                    v-tooltip.top="'Seleccionar Método de Pago'"
                  />
                  <span :class="'p-tag p-tag-rounded' + (total_venta == 0 ? ' bg-black-alpha-20' : ' p-tag-success')"
                    >PAGO QR</span
                  >
                </template>
                <template v-if="'Proforma Crear' in auth.user.permissions">
                  <Checkbox
                    class="ml-3 mr-1"
                    value="proforma"
                    :binary="true"
                    v-tooltip.top="'Crear como proforma'"
                    v-model="proforma"
                    :disabled="total_venta == 0"
                  />
                  <span :class="'p-tag p-tag-rounded' + (total_venta == 0 ? ' bg-black-alpha-20' : ' p-tag-danger')"
                    >PROFORMA</span
                  >
                </template>
              </div>
            </div>
            <div class="field col-12 md:col-12">
              <table>
                <tr v-if="a_credito_check == 'a_credito_check'">
                  <td>
                    <strong>TIPO DE PAGO: </strong>
                  </td>
                  <td>
                    <Dropdown
                      id="tipo_pago"
                      v-model="tipo_pagoSelect"
                      :options="tipo_pagos"
                      optionLabel="nombre"
                      optionValue="id"
                    />
                  </td>
                </tr>
                <tr v-if="tipo_pagoSelect == 2">
                  <td>
                    <strong>D&Iacute;AS CR&Eacute;DITO: </strong>
                  </td>
                  <td>
                    <InputNumber
                      v-model="dias_credito"
                      :min="1"
                      :inputClass="'text-right'"
                      locale="de-ED"
                      :useGrouping="false"
                      showButtons
                    />
                  </td>
                </tr>
                <tr v-if="venta_credito in auth.user.permissions">
                  <td>
                    <strong>INTERES %: </strong>
                  </td>
                  <td>
                    <InputNumber
                      v-model="interes_venta_a_credito"
                      :min="0"
                      :inputClass="'text-right'"
                      locale="de-ED"
                      :minFractionDigits="2"
                      :useGrouping="false"
                      showButtons
                      placeholder="porcentaje interes"
                    />
                  </td>
                </tr>
                <tr v-if="venta_credito">
                  <td>
                    <strong>A CUENTA EFECTIVO: </strong>
                  </td>
                  <td>
                    <InputNumber
                      v-model="a_cuenta"
                      :min="0"
                      :max="total_venta - monto_pago - 1"
                      :inputClass="'text-right'"
                      locale="de-ED"
                      :minFractionDigits="2"
                      :useGrouping="false"
                      showButtons
                      placeholder="a cuenta efectivo"
                    />
                  </td>
                </tr>
                <tr v-if="metodo_pago_check == 'metodo_pago_check'">
                  <td>
                    <strong>M&Eacute;TODO PAGO: </strong>
                  </td>
                  <td>
                    <Dropdown
                      id="metodo_pago"
                      v-model="metodo_pagoSelect"
                      :options="metodo_pagos"
                      optionLabel="nombre"
                      optionValue="id"
                    />
                  </td>
                </tr>
                <tr v-if="metodo_pagoSelect == 6 && qr_cobros != null">
                  <td>
                    <strong>QR COBROS: </strong>
                  </td>
                  <td>
                    <Image :src="'data:image/png;base64, ' + qr_cobros" width="150" preview></Image>
                  </td>
                </tr>
                <tr v-if="metodo_pagoSelect == 2 && facturar == 1">
                  <td>
                    <strong>Nº TARJETA: </strong>
                  </td>
                  <td>
                    <div class="flex flex-column">
                      <InputText
                        v-model="nro_tarjeta"
                        type="text"
                        class="text-right"
                        placeholder="Ej: 12345678"
                        maxlength="8"
                        @input="validarTarjetaInput"
                        @keypress="soloNumeros($event)"
                        :class="{
                          'p-invalid': nro_tarjeta && nro_tarjeta.length !== 8
                        }"
                      />
                      <small
                        class="mt-1"
                        :class="nro_tarjeta && nro_tarjeta.length === 8 ? 'text-green-600' : 'p-error'"
                      >
                        <i
                          :class="
                            nro_tarjeta && nro_tarjeta.length === 8
                              ? 'pi pi-check-circle'
                              : 'pi pi-exclamation-triangle'
                          "
                        ></i>
                        {{ nro_tarjeta ? nro_tarjeta.length : 0 }}/8 dígitos
                      </small>
                    </div>
                  </td>
                </tr>
                <tr v-if="metodo_pagoSelect != 1">
                  <td>
                    <strong>MONTO QR: </strong>
                  </td>
                  <td>
                    <InputNumber
                      v-model="monto_pago"
                      :min="0"
                      :max="total_venta - a_cuenta"
                      :inputClass="'text-right'"
                      locale="de-ED"
                      :useGrouping="false"
                      :minFractionDigits="2"
                      showButtons
                      placeholder="Monto Pago"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="field col-12 md:col-6 hidden">
              <span><strong>Cotizaci&oacute;n</strong></span>
              <Checkbox class="ml-3" value="cotizar" v-model="cotizar" />
            </div>
            <table class="field col-12 md:col-12">
              <tr v-if="!venta_credito">
                <td>
                  <strong>RECIBIDO EN EFECTIVO:</strong>
                </td>
                <td class="text-right">
                  <InputNumber
                    v-model="efectivo"
                    :min="total_venta - monto_pago - a_cuenta"
                    locale="de-DE"
                    input-class="text-right"
                    :minFractionDigits="2"
                    inputId="locale-german"
                    :disabled="metodo_pagoSelect != 1 ? true : false || a_credito_check == 'a_credito_check'"
                  />
                </td>
              </tr>
              <tr v-if="venta_credito">
                <td>
                  <strong>SALDO DEBE:</strong>
                </td>
                <td class="text-right">
                  <InputNumber
                    v-model="venta_credito_saldo_debe"
                    :min="0"
                    locale="de-DE"
                    input-class="text-right"
                    :minFractionDigits="2"
                    inputId="locale-german"
                  />
                </td>
              </tr>
              <tr v-if="venta_credito">
                <td>
                  <strong> MONTO INTERES: </strong>
                </td>
                <td class="text-right">
                  <InputNumber
                    v-model="monto_venta_a_credito_interes"
                    :min="0"
                    locale="de-DE"
                    input-class="text-right"
                    :minFractionDigits="2"
                    inputId="locale-german"
                  />
                </td>
              </tr>

              <tr v-if="!venta_credito">
                <td>
                  <strong>
                    <h2>CAMBIO:</h2>
                  </strong>
                </td>
                <td class="text-right p-invalid">
                  <strong>
                    <h1>{{ convertirNumeroGermanicFormat(cambio) }} Bs.</h1>
                  </strong>
                </td>
              </tr>
            </table>
            <div class="col-12 md:col-12 flex justify-content-end">
              <Button
                icon="pi pi-refresh"
                class="p-button-warning"
                v-tooltip.top="'Detener y Volver a Empezar'"
                @click="guardando = false"
                v-if="guardando"
                :disabled="productosVentas.length == 0"
              />
              <Button
                :label="proforma == 1 ? 'REGISTRAR PROFORMA' : facturar == 1 ? 'REGISTRAR FACTURA' : 'REGISTRAR VENTA'"
                icon="pi pi-save"
                v-tooltip.top="
                  proforma == 1 ? 'Registrar Proforma' : facturar == 1 ? 'Registrar Factura' : 'Registrar Venta'
                "
                class="p-button-info p-button-lg"
                @click="guardarVenta"
                :disabled="productosVentas.length == 0"
                :loading="guardando"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid" v-else>
      <Message class="col-12" :severity="'info'" :closable="false">
        <div class="flex align-items-center justify-content-center">
          <span> PARA REALIZAR VENTAS DEBE ABRIR LA CAJA </span>
          <Button
            label="APERTURAR CAJA"
            class="p-button-success p-button-lg ml-3"
            icon="pi pi-lock-open"
            v-tooltip.top="'Abrir Caja'"
            @click="this.$router.push({ name: 'caja' })"
          />
        </div>
      </Message>
    </div>
  </div>
  <div v-else>
    <div class="grid">
      <h3 class="col-12">Verificando caja ...</h3>
      <ProgressSpinner
        style="width: 50px; height: 50px"
        strokeWidth="8"
        fill="var(--surface-ground)"
        animationDuration=".5s"
        class="col-12"
      />
    </div>
  </div>
  <!-- MODAL DE LOADING PARA FACTURACIÓN -->
  <Dialog
    v-model:visible="facturando"
    :modal="true"
    :closable="false"
    :draggable="false"
    :style="{ width: '300px' }"
    header="PROCESANDO FACTURA"
    class="modal-facturacion"
  >
    <div class="loading-content">
      <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="8" fill="transparent" animationDuration="1s" />

      <div class="loading-info mt-4">
        <p class="text-secondary">{{ detalleFacturacion }}</p>

        <div class="warning-box mt-4">
          <i class="pi pi-info-circle mr-2"></i>
          <span>Esto puede tardar unos segundos...</span>
        </div>
      </div>
    </div>
  </Dialog>

  <TimeoutFacturaDialog
    v-if="timeoutDialogVisible"
    v-model="timeoutDialogVisible"
    :venta-id="timeoutVentaId"
    :loading="buscandoFactura"
    @buscar-factura="buscarFacturaTimeout"
    @ir-detalle="irADetalleVenta"
  />
  <ClienteCreate
    v-if="clienteModal"
    :show="clienteModal"
    :cliente="cliente"
    @closeModal="cerrarModalCliente"
    @actualizarListado="cargarClientesListado"
  >
  </ClienteCreate>
  <ClienteFactura
    v-if="clienteFacturaModal"
    :show="clienteFacturaModal"
    :cliente_factura="cliente_factura"
    @closeModal="cerrarModalClienteFactura"
    @actualizarListado="cargarClienteFactura"
  >
  </ClienteFactura>

  <ProducoListadoModal
    v-if="productosResultados"
    @closeModal="cerrarModalProductoResultados"
    :show="productosResultados"
    :productos="productosFiltrados"
    :mostrar_cif="mostrar_cif"
    :mostrar_codigo_origen="mostrar_codigo_origen"
    :mostrar_medidas="mostrar_medidas"
    @agregarProductos="agregarProductos"
  ></ProducoListadoModal>
  <VehiculoCreate
    v-if="vehiculoModal"
    :show="vehiculoModal"
    :vehiculo="vehiculo"
    @closeModalVehiculo="cerrarModalVehiculo"
    @actualizarListadoVehiculo="cargarVehiculos"
  >
  </VehiculoCreate>
</template>

<script>
import ClienteService from '@/service/ClienteService'
import ProductService from '@/service/ProductService'
import VentaService from '@/service/VentaService'
import ClienteCreate from '@/module/clientes/ClienteCreate.vue'
import ClienteFactura from '@/module/clientes_facturas/ClienteFactura.vue'
import CajaService from '@/service/CajaService'
import { useAuth } from '@/stores'
import { has } from 'lodash'
import TipoPagoService from '@/service/TipoPagoService'
import MetodoPagoService from '@/service/MetodoPagoService'
import PaqueteProductoService from '@/service/PaqueteProductoService'
import FacturaService from '@/service/FacturaService'
import MedicoService from '@/service/MedicoService'
import ParametrosSistemaService from '@/service/ParametrosSistemaService'
import ProducoListadoModal from '@/module/productos/ProductoListadoModal.vue'
import EmpresaService from '@/service/EmpresaService'
import VehiculoCreate from '@/module/vehiculos/VehiculoCreate.vue'
import VehiculoService from '@/service/VehiculoService'
import { debounce } from '@/helpers/debounce'
import TimeoutFacturaDialog from '@/components/TimeoutFacturaDialog.vue'
import StockService from '@/service/StockService'
import AgendaService from '@/service/AgendaService'

export default {
  components: {
    ClienteCreate,
    ClienteFactura,
    ProducoListadoModal,
    VehiculoCreate,
    TimeoutFacturaDialog
  },
  data() {
    return {
      buscarProductoPorSelected: ['nombre_comercial'],
      buscarProductoPorListado: [
        { label: 'NOMBRE', value: 'nombre_comercial' },
        { label: 'CÓD INTERNO', value: 'codigo_interno' },
        { label: 'MEDIDAS', value: 'medidas' }
      ],
      grupoSelected: null,
      laboratorioSelected: null,
      laboratorios: [],
      laboratoriosListadoFiltrado: [],
      grupos: [],
      venta_credito_saldo_debe: 0,
      proforma: false,
      permitir_facturar: false,
      facturar: false,
      cotizar: false,
      guardando: false,
      clienteSelect: null,
      clientes: [],
      razon_social: null,
      nit: 0,
      productoSelecionado: null,
      productosListadoFiltrado: [],
      productosVentas: [],
      stockSucursales: [],
      subtotal: 0,
      descuento: 0,
      total_venta: 0,
      efectivo: 0,
      monto_pago: 0, //monto de pago en efectivo
      clienteModal: false,
      clienteFacturaModal: false,
      cliente: { estado: { label: 'Activo', value: 1 } },
      clienteFactura: { estado: { label: 'Activo', value: 1 } },
      medico: { estado: { label: 'Activo', value: 1 } },
      fecha_venta: null,
      permitirVenta: false,
      cargandoComponente: false,
      sucursal_id: null,
      caja: null,
      desc_venta_porcentaje: null,
      aplica_descuento: false,
      tipo_pagos: [],
      tipo_pagoSelect: 1,
      metodo_pagos: [],
      metodo_pagoSelect: 1,
      dias_credito: 0,
      a_cuenta: 0,
      venta_credito: false,
      saldo: 0,
      observacion: '',
      observacion_check: false,
      a_credito_check: false,
      metodo_pago_check: false,
      stockClass: (data) => {
        if (data <= 0) {
          return 'outofstock'
        } else if (data <= 10) {
          return 'lowstock'
        } else {
          return 'instock'
        }
      },
      claseEstado: (data) => {
        if (data.cantidad <= 0) {
          return 'outofstock'
        } else if (data.cantidad <= 10) {
          return 'lowstock'
        } else {
          return 'instock'
        }
      },
      vender_paquete: false,
      paqueteSelected: null,
      paqueteproductos: [],
      paqueteproductosListado: [],
      entregado: 0,
      medico_referencia: false,
      medicos: [],
      medicoSelected: null,
      productosResultados: false,
      productosFiltrados: [],
      actividades_economicas: [],
      actividad_economica_selected: null,
      nro_tarjeta: null,
      filtrosRadio: 'precio_venta',
      cliente_factura: {},
      monto_venta_a_credito_interes: 0,
      interes_venta_a_credito: 0,
      grupos_id_selected: '',
      qr_cobros: null,
      vehiculoModal: false,
      vehiculo: {},
      tipo_negocio: 1,
      fact_indicador: false,
      buscar_proforma: false,
      proforma_codigo: null,
      proforma_id: null,
      parametros_sistema: {},
      stock_decimales: false,
      mostrar_fecha_venta: false,
      venta_fecha_diferente: false,
      codigo_barra: null,
      panelColapsado: false,
      vender_con_codigo_barra: false,
      vender_con_caso_uso: false,
      caso_uso: null,
      tiene_membresia_activa: false,
      membresias_activas: [],
      mostrar_cif: false,
      mostrar_codigo_interno: false,
      mostrar_codigo_origen: false,
      fecha_membresia_hasta: null,
      permisoActivarModalProductos: false,
      abortController: null,
      buscar_sin_enter: false,
      limite_busqueda_productos: 50,
      mostrar_actividad_economica: false,
      registrar_para_facturacion: false,
      punto_venta_id: null,
      codigo_punto_venta: null,
      ver_medico_detalle: false,

      // Variables para modal de facturación
      facturando: false,
      detalleFacturacion: 'Por favor espere mientras procesamos su factura',
      buscandoFactura: false,
      timeoutDialogVisible: false,
      timeoutVentaId: null,

      cacheBusquedaCliente: new Map(),
      cacheBusquedaProducto: new Map(),
      cacheBusquedaNit: new Map(),
      cargandoClientes: false,
      cargandoProductos: false,
      cargandoNit: false,

      nitClienteSelect: null, // Para el AutoComplete
      nitClientesFiltrados: [], // Resultados filtrados

      mostrar_codigos_extra: false,
      vieneDeProforma: false,
      mostrar_cod_cliente_en_venta: false,
      mostrar_medidas: false,
      auto_seleccionar_trabajador: false,
      vieneDeAgenda: false,
      agenda_reserva: null,
      permitir_stock_negativo: false
    }
  },
  clienteService: null,
  productService: null,
  ventaService: null,
  cajaService: null,
  auth: null,
  tipoPagoService: null,
  metodoPagoService: null,
  paqueteProductoService: null,
  medicoService: null,
  facturaService: null,
  parametrosSistemaService: null,
  empresaService: null,
  vehiculoService: null,
  stockService: null,
  agendaService: null,

  created() {
    this.auth = useAuth()
    this.clienteService = new ClienteService()
    this.productService = new ProductService()
    this.ventaService = new VentaService()
    this.cajaService = new CajaService()
    this.tipoPagoService = new TipoPagoService()
    this.metodoPagoService = new MetodoPagoService()
    this.paqueteProductoService = new PaqueteProductoService()
    this.medicoService = new MedicoService()
    this.facturaService = new FacturaService()
    this.parametrosSistemaService = new ParametrosSistemaService()
    this.empresaService = new EmpresaService()
    this.vehiculoService = new VehiculoService()
    this.stockService = new StockService()

    // Inicializar debounce
    this.buscarClienteDebounced = debounce(this.buscarClienteImpl, 400)
    this.buscarProductoDebounced = debounce(this.buscarProductoImpl, 400)
    this.buscarClientePorNitDebounced = debounce(this.buscarClientePorNitImpl, 400)

    this.agendaService = new AgendaService()
  },
  mounted() {
    this.datos_venta_general()

    if (this.$route.query.proforma_id) {
      this.buscar_proforma = true
      this.proforma_codigo = this.$route.query.proforma_id
      this.$nextTick(() => {
        this.agregarProductosProforma()

        let query = Object.assign({}, this.$route.query)
        delete query.proforma_id
        this.$router.replace({ query })
      })
    }
    if (this.$route.query.agenda_id) {
      this.$nextTick(() => {
        this.cargarDesdeAgenda(this.$route.query.agenda_id)
      })
    }
  },

  computed: {
    cambio() {
      if (this.tipo_pagoSelect == 2) {
        return this.efectivo - this.a_cuenta
      } else {
        return this.efectivo + this.monto_pago - this.total_venta
      }
    },
    computedBuscarProductoPorSelected() {
      return this.buscarProductoPorSelected.includes('caso_uso')
    },
    listaFiltrosVisual() {
      // 1. Clonamos tu lista original para no alterarla
      let lista = [...this.buscarProductoPorListado]

      // 2. Si el permiso está activo, agregamos los nuevos filtros
      if (this.mostrar_codigos_extra) {
        lista.push({ label: 'CÓD. ORIGEN', value: 'codigo_origen' })
        lista.push({ label: 'CÓD. EQUIV', value: 'codigo_equivalente' })
      }

      return lista
    }
  },

  beforeUnmount() {
    this.cacheBusquedaCliente.clear()
    this.cacheBusquedaProducto.clear()
    this.cacheBusquedaNit.clear()
  },

  methods: {
    limpiarAgenda() {
      this.vieneDeAgenda = false
      this.agenda_reserva = null
      this.productosVentas = []
      this.clienteSelect = null
      this.calcular_subtotal()
    },
    async cargarDesdeAgenda(agenda_id) {
      const res = await this.agendaService.getAgenda(agenda_id)
      if (!res.success) return

      const agenda = res.agenda

      // Cargar cliente sin badge de tipo
      this.clienteSelect = {
        id: agenda.cliente_id,
        nombre: agenda.nombre_cliente,
        ci_nit: '',
        tipo_cliente: 0
      }

      const precio = parseFloat(agenda.precio) || 0
      const anticipo = parseFloat(agenda.anticipo) || 0
      const saldo = precio - anticipo

      if (saldo > 0) {
        let stockItem = null
        let fabrica_nombre = null
        let cantidad = 9999

        // Buscar el producto para obtener stock real y fabrica_nombre
        if (agenda.nombre_producto && this.sucursal_id) {
          try {
            const resProd = await this.productService.buscarProductosOptimizado({
              texto: agenda.nombre_producto,
              buscarProductoPorSelected: ['nombre_comercial'],
              sucursal_id: this.sucursal_id,
              limite_busqueda_productos: 5
            })

            // Buscar exacto por producto_id o tomar el primero
            const prod =
              resProd?.productos?.find((p) => p.id === parseInt(agenda.producto_id)) || resProd?.productos?.[0]

            if (prod) {
              stockItem = prod.stock?.[0] ?? null
              fabrica_nombre = prod.fabrica_nombre || null
              cantidad = stockItem ? parseFloat(stockItem.cantidad) : 9999
            }
          } catch (e) {
            console.warn('No se pudo obtener el producto de la agenda', e)
          }
        }

        this.productosVentas.push({
          id: parseInt(agenda.producto_id),
          producto_id: parseInt(agenda.producto_id),
          nombre_producto: agenda.nombre_producto || agenda.observacion || 'Reserva cancha',
          tipo_catalogo: 2,
          cantidad: cantidad,
          cantidad_venta: 1,
          ultimo_precio: saldo,
          precio_sugerido: saldo,
          total: saldo,
          descuento_neto: 0,
          descuento_porcentaje: 0,
          fabrica_nombre: fabrica_nombre,
          nombre_fabrica: fabrica_nombre,
          codigo_interno: null,
          lote: stockItem?.lote ?? null,
          fecha_vence: stockItem?.fecha_vence ?? null,
          producto: {
            fabrica_nombre: fabrica_nombre
          }
        })

        this.calcular_subtotal()
      }

      // Banner de reserva
      this.vieneDeAgenda = true
      this.agenda_reserva = agenda

      this.$toast.add({
        severity: 'info',
        summary: 'Reserva cargada',
        detail: `${agenda.nombre_cliente} · Saldo a cobrar: ${saldo.toFixed(2)} Bs`,
        life: 3000
      })

      // Limpiar query param para evitar recarga
      const query = Object.assign({}, this.$route.query)
      delete query.agenda_id
      this.$router.replace({ query })
    },
    rowClassDetalle(data) {
      if (
        !this.permitir_stock_negativo &&
        data.tipo_catalogo == 1 &&
        (data.cantidad <= 0 || data.cantidad_venta > data.cantidad)
      ) {
        return 'fila-sin-stock-alerta'
      }
      return ''
    },
    limpiarFiltrosBusquedaProducto() {
      this.grupoSelected = null
      this.laboratorioSelected = null
      this.buscarProductoPorSelected = ['nombre_comercial']
      this.caso_uso = null
      this.productosListadoFiltrado = []

      this.$toast.add({
        severity: 'info',
        summary: 'Filtros',
        detail: 'Filtros limpiados correctamente',
        life: 2000
      })
    },
    buscarLaboratorio(event) {
      setTimeout(() => {
        this.stockService.buscarLaboratorioXNombre({ texto: event.query }).then((response) => {
          this.laboratoriosListadoFiltrado = [...response.laboratorios]
        })
      }, 250)
    },
    obtenerPrecioMostrar(producto) {
      // Normalizar: usa tipo_cliente, pero fallback a tipo_cliente_id por compatibilidad
      const tipoCliente = this.clienteSelect?.tipo_cliente ?? this.clienteSelect?.tipo_cliente_id ?? 0

      if (!this.clienteSelect || tipoCliente == 0) {
        return this.obtenerPrecioSegunTipo(producto, 'default')
      }

      if (tipoCliente == 1 || tipoCliente == 2) {
        return this.obtenerPrecioSegunTipo(producto, 'pv2')
      }

      if (tipoCliente == 3) {
        return this.obtenerPrecioSegunTipo(producto, 'pv3')
      }

      return this.obtenerPrecioSegunTipo(producto, 'default')
    },

    // Método auxiliar para determinar el precio según tipo
    obtenerPrecioSegunTipo(producto, tipoPrecio) {
      // PARA SERVICIOS (tipo_catalogo == 2)
      if (producto.tipo_catalogo == 2) {
        switch (tipoPrecio) {
          case 'pv2':
            return producto.pv2 || producto.precio_sugerido || '0.00'
          case 'pv3':
            return producto.pv3 || producto.precio_sugerido || '0.00'
          default:
            return producto.precio_sugerido || '0.00'
        }
      }

      // PARA PRODUCTOS (tipo_catalogo == 1)
      if (producto.tipo_catalogo == 1) {
        // Si no tiene stock registrado
        if (!producto.stock || producto.stock.length === 0) {
          switch (tipoPrecio) {
            case 'pv2':
              return producto.pv2 || producto.precio_sugerido || '0.00'
            case 'pv3':
              return producto.pv3 || producto.precio_sugerido || '0.00'
            default:
              return producto.precio_sugerido || '0.00'
          }
        }

        // Si tiene stock
        const stockItem = producto.stock[0]
        switch (tipoPrecio) {
          case 'pv2':
            return stockItem.pv2 || producto.pv2 || producto.precio_sugerido || '0.00'
          case 'pv3':
            return stockItem.pv3 || producto.pv3 || producto.precio_sugerido || '0.00'
          default:
            return stockItem.ultimo_precio || producto.precio_sugerido || '0.00'
        }
      }

      return '0.00'
    },
    async procesarGuardadoVenta(datos) {
      if (this.guardando) return

      this.guardando = true

      if (this.facturar) {
        this.facturando = true
        this.detalleFacturacion =
          'Enviando factura al sistema de impuestos. Por favor no cierre esta ventana ni realice otras acciones hasta que se complete el proceso.'
      }

      try {
        const res = await this.ventaService.crear(datos)

        this.facturando = false
        this.guardando = false

        // Manejo de proforma
        if (has(res, 'proforma')) {
          this.$toast.add({
            severity: 'success',
            summary: 'Venta',
            detail: 'Proforma Realizada con Éxito',
            life: 3000
          })
          this.$router.push({
            name: 'proforma_detalle',
            params: { id: res.proforma.id }
          })
          return
        }

        // Error de validación
        if (res.status === 400 || res.status === 422) {
          this.$toast.add({
            severity: 'error',
            summary: 'Error al Procesar la Venta',
            detail: res.message || res.mensaje || 'Error de validación',
            life: 10000
          })
          return
        }

        // Timeout del SIN
        if (res.status === 206) {
          const ventaId = res.venta?.id

          if (res.puede_reintentar && ventaId && typeof ventaId === 'number') {
            this.mostrarDialogTimeout(ventaId)
          } else if (ventaId) {
            this.$toast.add({
              severity: 'warn',
              summary: 'Venta Sin Factura',
              detail: `Venta #${ventaId} guardada sin factura: ${res.error_detallado}`,
              life: 10000
            })

            setTimeout(() => {
              this.$router.push({
                name: 'venta_detalle',
                params: { id: ventaId }
              })
            }, 2000)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error Crítico',
              detail: 'No se pudo obtener el ID de la venta',
              life: 10000
            })
          }
          return
        }

        // Éxito
        if (res.status === 200) {
          this.$toast.add({
            severity: 'success',
            summary: '¡Venta Exitosa!',
            detail: res.mensaje || 'Venta registrada correctamente',
            life: 3000
          })

          setTimeout(() => {
            this.$router.push({
              name: 'venta_detalle',
              params: { id: res.venta.id }
            })
          }, 500)
          return
        }

        // Respuesta inesperada
        this.$toast.add({
          severity: 'warn',
          summary: 'Respuesta Inesperada',
          detail: 'La operación completó con un código no esperado',
          life: 5000
        })
      } catch (error) {
        this.facturando = false
        this.guardando = false

        let detalleError = 'No se pudo conectar con el servidor'

        if (error.response) {
          detalleError =
            error.response.data?.message || error.response.data?.mensaje || `Error ${error.response.status}`
        }

        this.$toast.add({
          severity: 'error',
          summary: 'Error de Conexión',
          detail: detalleError,
          life: 10000
        })
      }
    },

    irADetalleVenta(ventaId) {
      if (!ventaId || ventaId === 0) return

      this.timeoutDialogVisible = false

      this.$router.push({
        name: 'venta_detalle',
        params: { id: ventaId }
      })
    },

    async buscarFacturaTimeout(ventaId) {
      if (!ventaId || ventaId === 0) return

      this.buscandoFactura = true
      this.facturando = true
      this.detalleFacturacion = 'Buscando factura en el SIN. Por favor espere...'

      try {
        const response = await this.ventaService.buscarFacturaTimeout(ventaId)

        this.facturando = false
        this.buscandoFactura = false

        if (response.encontrada) {
          this.$toast.add({
            severity: 'success',
            summary: 'Factura Encontrada',
            detail: response.mensaje || 'La factura fue generada correctamente',
            life: 5000
          })

          this.timeoutDialogVisible = false

          setTimeout(() => {
            this.$router.push({
              name: 'venta_detalle',
              params: { id: ventaId }
            })
          }, 1000)
        } else {
          this.$toast.add({
            severity: 'warn',
            summary: 'Factura No Encontrada',
            detail: response.mensaje || 'No se encontró la factura en el SIN. Intenta nuevamente en unos minutos.',
            life: 8000
          })
        }
      } catch (error) {
        this.facturando = false
        this.buscandoFactura = false

        this.$toast.add({
          severity: 'error',
          summary: 'Error de Conexión',
          detail: 'No se pudo conectar con el servidor. Intenta nuevamente.',
          life: 8000
        })
      }
    },

    mostrarDialogTimeout(ventaId) {
      if (!ventaId || typeof ventaId !== 'number') {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo obtener el ID de la venta',
          life: 5000
        })
        return
      }

      this.$nextTick(() => {
        this.timeoutVentaId = ventaId
        this.timeoutDialogVisible = true
      })
    },

    // Permitir solo números
    soloNumeros(event) {
      const char = String.fromCharCode(event.keyCode)
      if (!/[0-9]/.test(char)) {
        event.preventDefault()
      }
    },

    // Validar y limitar a 8 dígitos
    validarTarjetaInput() {
      if (this.nro_tarjeta) {
        this.nro_tarjeta = this.nro_tarjeta.replace(/\D/g, '')

        if (this.nro_tarjeta.length > 8) {
          this.nro_tarjeta = this.nro_tarjeta.substring(0, 8)
        }
      }
    },

    async cargarClienteFactura(response) {
      const cliente_factura = response?.cliente_factura || response

      if (!cliente_factura || !cliente_factura.ci_nit) {
        return
      }

      const nitValue = cliente_factura.ci_nit
      const nombreValue = cliente_factura.nombre

      this.nit = nitValue
      this.razon_social = nombreValue

      this.nitClienteSelect = nitValue
    },

    async buscarClientePorNitConEnter() {
      if (!this.nitClienteSelect || this.nitClienteSelect.length < 3) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Búsqueda',
          detail: 'Ingrese al menos 3 caracteres',
          life: 3000
        })
        return
      }

      this.cargandoNit = true

      try {
        const texto = this.nitClienteSelect.trim()

        const response = await this.clienteService.buscarClientesNitOptimizado({
          texto: texto,
          limite: 20
        })

        const data = response.data || response

        if (data.status === 200 && data.success && data.clientes?.length > 0) {
          this.nitClientesFiltrados = data.clientes

          // Guardar en caché para AutoComplete
          const cacheKey = `nit_${texto.toLowerCase()}`
          this.cacheBusquedaNit.set(cacheKey, data.clientes)

          // Limpiar caché viejo
          if (this.cacheBusquedaNit.size > 20) {
            const firstKey = this.cacheBusquedaNit.keys().next().value
            this.cacheBusquedaNit.delete(firstKey)
          }
        } else {
          this.nitClientesFiltrados = []
          this.$toast.add({
            severity: 'info',
            summary: 'Sin resultados',
            detail: data.mensaje || 'No se encontraron clientes',
            life: 6000
          })
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error de Búsqueda',
          detail: 'No se pudo realizar la búsqueda',
          life: 5000
        })
        this.nitClientesFiltrados = []
      } finally {
        this.cargandoNit = false
      }
    },

    async buscarClientePorNitImpl(texto, cacheKey) {
      this.cargandoNit = true

      try {
        const response = await this.clienteService.buscarClientesNitOptimizado({
          texto: texto,
          limite: 20
        })

        const data = response.data || response

        if (data.status === 200 && data.success && data.clientes?.length > 0) {
          this.nitClientesFiltrados = data.clientes

          // Guardar en caché
          if (this.cacheBusquedaNit) {
            this.cacheBusquedaNit.set(cacheKey, data.clientes)

            // Limpiar caché viejo
            if (this.cacheBusquedaNit.size > 20) {
              const firstKey = this.cacheBusquedaNit.keys().next().value
              this.cacheBusquedaNit.delete(firstKey)
            }
          }
        } else if (data.status === 404) {
          this.nitClientesFiltrados = []
        }
      } catch (error) {
        this.nitClientesFiltrados = []
        this.$toast.add({
          severity: 'error',
          summary: 'Error de Búsqueda',
          detail: 'No se pudo realizar la búsqueda',
          life: 5000
        })
      } finally {
        this.cargandoNit = false
      }
    },

    verificarCliente() {
      if (!this.clienteSelect) {
        this.$toast.add({
          severity: 'error',
          summary: 'CLIENTE',
          detail: 'DEBE SELECCIONAR UN CLIENTE',
          life: 10000
        })
        return true
      }

      const tieneIdValido =
        (this.clienteSelect.id != null && this.clienteSelect.id !== undefined) ||
        (this.clienteSelect.cliente_id != null && this.clienteSelect.cliente_id !== undefined)

      if (!tieneIdValido) {
        this.$toast.add({
          severity: 'error',
          summary: 'CLIENTE',
          detail: 'DEBE SELECCIONAR UN CLIENTE',
          life: 10000
        })
        return true
      }

      return false
    },

    async seleccionarClienteNit(event) {
      const clienteSeleccionado = event.value

      if (!clienteSeleccionado) return

      // Asignamos valores a la vista
      this.nit = clienteSeleccionado.ci_nit
      this.razon_social = clienteSeleccionado.nombre
      this.nitClienteSelect = clienteSeleccionado.ci_nit
    },

    obtenerNombreTipoDocumento(tipo) {
      const tipos = {
        1: 'CI',
        2: 'CEX',
        3: 'PAS',
        4: 'OD',
        5: 'NIT'
      }
      return tipos[tipo] || 'DOC'
    },

    buscarCliente(event) {
      // Si clienteSelect es un objeto (cliente ya seleccionado), extraer solo el texto
      const texto =
        typeof this.clienteSelect === 'string' ? this.clienteSelect.trim() : this.clienteSelect?.nombre || ''

      // Limpiar resultados si no hay texto
      if (!texto || texto.length < 1) {
        this.clientes = []
        return
      }

      const cacheKey = `cliente_${texto.toLowerCase()}`

      // ENTER o Click: buscar inmediatamente sin caché
      const esBusquedaDirecta = (event?.type === 'keyup' && event?.key === 'Enter') || event?.type === 'click'

      if (esBusquedaDirecta) {
        // Limpiar caché para forzar búsqueda fresca
        this.cacheBusquedaCliente.delete(cacheKey)
        this.buscarClienteImpl(texto, cacheKey)
        return
      }

      // Verificar caché solo si NO es una búsqueda directa
      if (this.cacheBusquedaCliente.has(cacheKey)) {
        this.clientes = this.cacheBusquedaCliente.get(cacheKey)
        return
      }

      // Usar debounce para búsqueda mientras se escribe
      this.buscarClienteDebounced(texto, cacheKey)
    },

    async buscarClienteImpl(texto, cacheKey) {
      this.cargandoClientes = true

      try {
        const response = await this.clienteService.buscarXNombre({
          texto: texto,
          sucursal_id: this.sucursal_id
        })

        if (response.clientes?.length > 0) {
          this.clientes = response.clientes

          // Guardar en caché
          this.cacheBusquedaCliente.set(cacheKey, this.clientes)

          // Limpiar caché viejo (LRU)
          if (this.cacheBusquedaCliente.size > 20) {
            const firstKey = this.cacheBusquedaCliente.keys().next().value
            this.cacheBusquedaCliente.delete(firstKey)
          }
        } else {
          this.clientes = []
          this.$toast.add({
            severity: 'info',
            summary: 'Sin Resultados',
            detail: 'No se encontraron clientes',
            life: 3000
          })
        }
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error de Búsqueda',
          detail: 'No se pudieron cargar los clientes',
          life: 3000
        })
        this.clientes = []
      } finally {
        this.cargandoClientes = false
      }
    },

    buscarProducto(event) {
      const texto =
        typeof this.productoSelecionado === 'string'
          ? this.productoSelecionado.trim()
          : this.productoSelecionado?.descripcion || ''

      if (!texto || texto.length < 1) {
        this.productosListadoFiltrado = []
        return
      }

      const cacheKey = this.generarCacheKeyProducto(texto)

      // ENTER o Click: buscar inmediatamente
      const esBusquedaDirecta = (event?.type === 'keyup' && event?.key === 'Enter') || event?.type === 'click'

      if (esBusquedaDirecta) {
        // Cancelar debounce pendiente si existe
        if (this.buscarProductoDebounced && this.buscarProductoDebounced.cancel) {
          this.buscarProductoDebounced.cancel()
        }

        this.cacheBusquedaProducto.delete(cacheKey)
        this.buscarProductoImpl(texto, cacheKey)
        return
      }

      // Verificar caché
      if (this.buscar_sin_enter && this.cacheBusquedaProducto.has(cacheKey)) {
        this.productosListadoFiltrado = this.cacheBusquedaProducto.get(cacheKey)

        if (this.permisoActivarModalProductos && this.productosListadoFiltrado.length > 0) {
          this.activarModalProductosFiltrados()
        }
        return
      }

      // Si NO tiene buscar_sin_enter, no hacer nada
      if (!this.buscar_sin_enter) {
        return
      }

      // Debounce solo si está escribiendo
      this.buscarProductoDebounced(texto, cacheKey)
    },

    manejadorBusquedaProducto(event) {
      // Solo buscar automáticamente si está habilitado
      if (this.buscar_sin_enter) {
        // NO llamar buscarProducto si es un evento de ENTER
        if (event?.type !== 'keyup' || event?.key !== 'Enter') {
          this.buscarProducto(event)
        }
      }
    },

    async buscarProductoImpl(texto, cacheKey) {
      // Cancelar petición anterior
      if (this.abortController) {
        this.abortController.abort()
      }

      // Evitar búsquedas duplicadas
      if (this.cargandoProductos) {
        return
      }

      this.abortController = new AbortController()
      this.cargandoProductos = true

      try {
        const response = await this.productService.buscarProductosOptimizado(
          {
            texto: texto,
            buscarProductoPorSelected: this.buscarProductoPorSelected,
            sucursal_id: this.sucursal_id,
            grupo_id: this.grupoSelected,
            laboratorio_id: this.laboratorioSelected,
            caso_uso: this.caso_uso,
            limite_busqueda_productos: this.limite_busqueda_productos,
            facturar: this.facturar,
            codigo_actividad: this.facturar ? this.actividad_economica_selected : null
          },
          {
            signal: this.abortController.signal
          }
        )

        if (response.productos?.length > 0) {
          this.productosListadoFiltrado = this.procesarProductos(response.productos)

          this.cacheBusquedaProducto.set(cacheKey, this.productosListadoFiltrado)

          if (this.cacheBusquedaProducto.size > 50) {
            const firstKey = this.cacheBusquedaProducto.keys().next().value
            this.cacheBusquedaProducto.delete(firstKey)
          }

          if (this.permisoActivarModalProductos) {
            this.activarModalProductosFiltrados()
          }
        } else {
          this.productosListadoFiltrado = []
          this.$toast.add({
            severity: 'info',
            summary: 'Sin Resultados',
            detail: 'No se encontraron productos',
            life: 3000
          })
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Búsqueda cancelada')
          return
        }

        this.$toast.add({
          severity: 'error',
          summary: 'Error de Búsqueda',
          detail: 'No se pudieron cargar los productos',
          life: 3000
        })
        this.productosListadoFiltrado = []
      } finally {
        this.cargandoProductos = false
        this.abortController = null
      }
    },

    generarCacheKeyProducto(texto) {
      const filtros = [
        texto.toLowerCase(),
        this.buscarProductoPorSelected.sort().join(','),
        this.grupoSelected || 'all',
        this.laboratorioSelected || 'all',
        this.caso_uso || ''
      ]
      return filtros.join('|')
    },

    procesarProductos(productos) {
      if ('Venta Membresia' in this.auth.user.permissions && this.tiene_membresia_activa) {
        return productos.map((producto) => {
          const membresia = this.membresias_activas.find((m) => m.nombre_producto === producto.descripcion)

          if (membresia && producto.stock?.[0]) {
            return {
              ...producto,
              stock: [
                {
                  ...producto.stock[0],
                  ultimo_precio: 0
                }
              ],
              es_con_membresia: true
            }
          }

          return producto
        })
      }

      return productos
    },

    onMedicoChange(event, slotProps) {
      const medicoId = event.value
      const medico = this.medicos.find((med) => med.id === medicoId)

      // Actualiza ambas propiedades
      slotProps.data.medico_id = medicoId
      slotProps.data.nombre_medico = medico ? medico.nombre_completo : null
    },

    openModalVehiculo() {
      this.vehiculo = {
        estado: { label: 'Activo', value: 1 },
        placa: this.clienteSelect && this.clienteSelect.nombre ? this.clienteSelect.nombre : this.clienteSelect || '',
        cliente_id: 1
      }
      this.vehiculoModal = true
    },
    cerrarModalVehiculo() {
      this.vehiculo = {}
      this.vehiculoModal = false
      //this.$emit("closeModalVehiculo");
    },
    togglePanelMasFiltros() {
      this.panelColapsado = !this.panelColapsado
    },
    cambiarActividadEconomica() {
      let datos = {
        codigoActividad: this.actividad_economica_selected,
        sucursal_id: this.sucursal_id
      }
      this.empresaService.changeActividad(datos).then((data) => {
        if (data.status == 200) {
          this.$toast.add({
            severity: 'success',
            summary: 'ACTIVIDAD ECONOMICA',
            detail: data.message,
            life: 3000
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cambiar la actividad economica',
            life: 3000
          })
        }
      })
    },
    calcular_agregar_des_total_venta() {
      this.calcular_descuento_venta_porcentaje()
      this.agregar_descuento_detalle_productosventas()
      this.calcular_total_venta()
    },
    calcular_agregar_des_total_venta_porcentaje() {
      this.calcular_descuento_venta_neto()
      this.agregar_descuento_detalle_productosventas()
      this.calcular_total_venta()
    },
    cerrarModalProductoResultados() {
      this.productosResultados = false
    },
    activarModalProductosFiltrados() {
      this.productosResultados = true
      //this.productosFiltrados = this.productosListadoFiltrado;
      this.productosFiltrados = this.productosListadoFiltrado.map((producto) => {
        return {
          ...producto,
          tipo_cliente: this.clienteSelect.tipo_cliente
        }
      })
    },
    datos_venta_general() {
      let datos = {
        verificar_caja: true,
        facturar: 'facturar'
      }

      this.ventaService.VentaGeneral(datos).then((response) => {
        if (response.success) {
          if (response.datos.caja.length == 0) {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se encontró una caja abierta'
            })
            this.permitirVenta = false
            this.cargandoComponente = true
            return
          }
          //codigo_sucursal
          this.caja = response.datos.caja[0]
          this.sucursal_id = response.datos.caja[0].sucursal_id
          this.punto_venta_id = response.datos.caja[0].punto_venta_id
          this.codigo_punto_venta = response.datos.caja[0].codigo_punto_venta
          this.qr_cobros = response.datos.qr_cobros
          this.permitirVenta = true

          this.tipo_negocio = response.datos.tipo_negocio ?? 1
          if (this.tipo_negocio != 2) {
            this.clientes = response.datos.clientes
            this.clienteSelect = this.clientes.length ? this.clientes[0] : null
          }
          this.tipo_pagos = response.datos.tipo_pagos
          this.metodo_pagos = response.datos.metodo_pagos
          this.paqueteproductos = response.datos.paquetes
          this.medicos = response.datos.medicos
          //si el usuario tien Venta ConMedico selecciono el primer medico Y ACTVIO EL CHECK
          /* v-if="'Venta ConMedico' in auth.user.permissions" */
          if (this.medicos.length > 0 && 'Venta ConMedico' in this.auth.user.permissions) {
            this.medico_referencia = true
            if (this.auto_seleccionar_trabajador) {
              this.medicoSelected = this.medicos[0].id
            }
          }
          this.grupos = response.datos.grupos

          if (response.datos.facturar) {
            this.permitir_facturar = true
          } else {
            this.permitir_facturar = false
          }
          this.actividades_economicas = response.datos.actividades_economicas || []
          if (this.actividades_economicas.length) {
            this.actividad_economica_selected = response.datos.actividad_economica_select.codigo
          }
          this.parametros_sistema = response.datos.parametros_sistema ?? {}
          this.parametros_sistema.some((parametro) => {
            if (parametro.nombre == 'stock_decimales') {
              this.stock_decimales = true
            }
            if (parametro.nombre == 'mostrar_fecha_venta') {
              this.mostrar_fecha_venta = true
            }
            if (parametro.nombre == 'vender_con_codigo_barra') {
              this.vender_con_codigo_barra = true
            }
            if (parametro.nombre == 'vender_con_caso_uso') {
              this.vender_con_caso_uso = true
            }
            if (parametro.nombre == 'mostrar_cif') {
              this.mostrar_cif = true
            }
            if (parametro.nombre == 'mostrar_codigo_interno') {
              this.mostrar_codigo_interno = true
            }

            this.permisoActivarModalProductos = this.parametros_sistema.some(
              (parametro) => parametro.nombre === 'permisoActivarModalProductos'
            )

            if (parametro.nombre == 'buscar_sin_enter') {
              this.buscar_sin_enter = true
            }

            if (parametro.nombre == 'registrar_para_facturacion') {
              this.registrar_para_facturacion = true
            }
            if (parametro.nombre == 'limite_busqueda_productos') {
              this.limite_busqueda_productos = parseInt(parametro.codigo)
            }
            if (parametro.nombre == 'mostrar_actividad_economica') {
              this.mostrar_actividad_economica = true
            }
            if (parametro.nombre == 'mostrar_codigos_extra') {
              this.mostrar_codigos_extra = true
            }
            if (parametro.nombre == 'panel_colapsado_filtros') {
              this.panelColapsado = true
            }
            if (parametro.nombre == 'mostrar_cod_cliente_en_venta') {
              this.mostrar_cod_cliente_en_venta = true
            }
            if (parametro.nombre == 'mostrar_codigo_origen') {
              this.mostrar_codigo_origen = true
            }
            if (parametro.nombre == 'mostrar_medidas') {
              this.mostrar_medidas = true
            }
            if (parametro.nombre == 'auto_seleccionar_trabajador') {
              this.auto_seleccionar_trabajador = true
            }
            if (parametro.nombre == 'permitir_stock_negativo') {
              this.permitir_stock_negativo = true
            }
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se encontró una caja abierta',
            life: 60000
          })
        }

        this.cargandoComponente = true
      })
    },
    verificarFacturar() {
      this.parametrosSistemaService.verificarPermiso('facturar').then((response) => {
        if (response.permiso) {
          this.permitir_facturar = true
        } else {
          this.permitir_facturar = false
        }
      })
    },
    obtenerMedicos() {
      this.medicoService.getMedicosAll().then((response) => {
        this.medicos = response.medicos
      })
    },
    obtenerPaquetes() {
      this.paqueteProductoService.getPaqueteProductoAll().then((response) => {
        this.paqueteproductos = response.paqueteproductos
      })
    },
    obtenerTiposPagos() {
      this.tipoPagoService.getAllTipoPagos().then((response) => {
        this.tipo_pagos = response.tipo_pagos
      })
    },

    aplicar_descuento_productos_detalle() {
      this.productosVentas.forEach((producto) => {
        producto.descuento_porcentaje = this.desc_venta_porcentaje
        producto.descuento_neto =
          producto.ultimo_precio * producto.cantidad_venta * (producto.descuento_porcentaje / 100)
      })
      this.calcular_subtotal()
    },
    /* buscarCliente() {
      let datos = {
        texto: this.clienteSelect ?? null,
        sucursal_id: this.sucursal_id,
      };
      if (this.clienteSelect != null) {
        this.clienteService.buscarXNombre(datos).then((response) => {
          if (response.clientes.length == 0) {
            this.$toast.add({
              severity: "error",
              summary: "ERROR",
              detail: "No se encontró el cliente",
              life: 3000,
            });
          }
          this.clientes = [...response.clientes];
        });
      }
    }, */
    verificarCajaAbierta() {
      this.cajaService.verificarCajaAbierta().then((response) => {
        if (response.caja.length > 0) {
          this.caja = response.caja[0]
          this.sucursal_id = response.caja[0].sucursal_id
          this.permitirVenta = true
        } else {
          this.permitirVenta = false
        }

        this.cargandoComponente = true
      })
    },

    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numero)
    },
    sinDecimal(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(numero)
    },

    verificarMetodoPago() {
      if (this.metodo_pagoSelect === 2 && this.facturar === true) {
        if (!this.nro_tarjeta || this.nro_tarjeta.trim() === '') {
          this.$toast.add({
            severity: 'error',
            summary: 'Número de Tarjeta Requerido',
            detail: 'Debe ingresar el número de tarjeta de 8 dígitos',
            life: 5000
          })
          return true
        }

        if (this.nro_tarjeta.length !== 8) {
          this.$toast.add({
            severity: 'error',
            summary: 'Número de Tarjeta Inválido',
            detail: `Debe tener exactamente 8 dígitos. Tiene: ${this.nro_tarjeta.length}`,
            life: 5000
          })
          return true
        }

        if (!/^\d{8}$/.test(this.nro_tarjeta)) {
          this.$toast.add({
            severity: 'error',
            summary: 'Número de Tarjeta Inválido',
            detail: 'El número de tarjeta debe contener solo dígitos',
            life: 5000
          })
          return true
        }
      }

      return false
    },
    verificarMedico() {
      if (this.medico_referencia == true && this.medicoSelected == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'TRABAJADOR',
          detail: 'Debe seleccionar un trabajador',
          life: 10000
        })
        return true
      }
      return false
    },
    verificarDatosFactura() {
      if (this.facturar === true && (!this.nit || this.nit.toString().trim() === '')) {
        this.$toast.add({
          severity: 'error',
          summary: 'NIT',
          detail: 'DEBE INGRESAR EL NIT',
          life: 10000
        })
        return true
      }
      return false
    },

    verificarProductosVenta() {
      let productos_invalidos = this.productosVentas.filter(
        (producto) => producto.cantidad_venta == 0 || producto.cantidad_venta == null || isNaN(producto.cantidad_venta)
      )

      if (productos_invalidos.length > 0) {
        this.$toast.add({
          severity: 'error',
          summary: 'Revisar productos con cantidad de venta en 0',
          detail: 'No puede guardar una venta con productos con cantidad de venta en 0',
          life: 60000
        })
        return true // Asegúrate de retornar true cuando hay error
      }

      return false // Asegúrate de retornar false cuando no hay error
    },

    guardarVenta() {
      if (!this.venta_credito && this.cambio < 0) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'El cambio debe ser mayor a 0',
          life: 60000
        })
        return
      }
      if (
        this.verificarMedico() ||
        this.verificarCliente() ||
        this.verificarMetodoPago() ||
        this.verificarDatosFactura() ||
        this.verificarProductosVenta()
      ) {
        return
      }

      let cliente_id =
        this.clienteSelect.cliente_id != null
          ? this.clienteSelect.cliente_id // Obtener el id del cliente de vehiculos
          : this.clienteSelect.id // Obtener el id del cliente de clientes

      let datos = {
        razon_social: this.razon_social,
        nit: this.nit,
        cliente_id: cliente_id,
        total_cancelar: this.total_venta,
        descuento: this.descuento,
        efectivo: this.efectivo,
        //productos: this.productosVentas,
        productos: this.productosVentas.map((p) => {
          if (!this.ver_medico_detalle && this.medico_referencia && this.medicoSelected) {
            return {
              ...p,
              medico_id: this.medicoSelected,
              nombre_medico: this.medicos.find((m) => m.id === this.medicoSelected)?.nombre_completo ?? null
            }
          }
          return p
        }),
        caja_id: this.caja.id,
        tipo_pago_id: this.tipo_pagoSelect,
        metodo_pago_id: this.metodo_pagoSelect,
        monto_pago: this.monto_pago,
        dias_credito: this.dias_credito,
        a_cuenta: this.a_cuenta,
        cambio: this.cambio,
        facturado: this.facturar ? 1 : 0,
        observacion: this.observacion,
        nombre_paquete: this.paqueteSelected ? this.paqueteSelected : 'VARIOS',
        nro_tarjeta: this.nro_tarjeta ? this.nro_tarjeta : null,
        proforma: this.proforma,
        interes_venta_credito: this.interes_venta_a_credito,
        monto_interes_venta_credito: this.monto_venta_a_credito_interes,
        venta_credito: this.venta_credito,
        vehiculo_id: this.clienteSelect.vehiculo_id ? this.clienteSelect.vehiculo_id : null,
        fact_indicador: this.fact_indicador ? 1 : 0,
        proforma_id: this.proforma_id,
        sucursal_id: this.sucursal_id,
        mostrar_fecha_venta: this.mostrar_fecha_venta,
        fecha_venta: this.fecha_venta,
        venta_fecha_diferente: this.venta_fecha_diferente,
        punto_venta_id: this.punto_venta_id,
        nombre_medico: this.medicoSelected
          ? this.medicos.find((medico) => medico.id === this.medicoSelected)?.nombre_completo ?? null
          : null,
        codigo_punto_venta: this.codigo_punto_venta,
        nombre_cliente: this.clienteSelect || this.clienteSelect.id ? this.clienteSelect.nombre : null,
        agenda_id: this.agenda_reserva?.id ?? null,
        permitir_stock_negativo: this.permitir_stock_negativo ? 1 : 0,
      }

      if (this.medico_referencia == true) {
        datos = { ...datos, medico_id: this.medicoSelected }
      }

      let texto_mensaje_confirmacion = this.proforma
        ? '¿ESTÁS SEGURO DE GUARDAR LA PROFORMA?'
        : this.facturar
        ? '¿ESTÁS SEGURO DE GUARDAR LA FACTURA?'
        : '¿ESTÁS SEGURO DE GUARDAR LA VENTA?'

      //fecha_venta: this.fecha_venta,

      if (this.productosVentas.length > 0) {
        this.$confirm.require({
          header: 'CONFIRMACIÓN',
          message: texto_mensaje_confirmacion,
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'REGISTRAR',
          rejectLabel: 'CANCELAR',
          acceptClass: 'p-button-primary p-button-lg',
          rejectClass: 'p-button-danger p-button-lg',
          acceptIcon: 'pi pi-save',
          rejectIcon: 'pi pi-times',
          closable: false,
          closeOnEscape: false,
          accept: () => {
            this.procesarGuardadoVenta(datos)
          },
          reject: () => {
            this.$toast.add({
              severity: 'info',
              summary: 'Venta',
              detail: 'Venta Cancelada',
              life: 3000
            })
            this.guardando = false
          }
        })
      }
    },
    activarCliente() {
      this.clienteModal = true
      this.cliente = {
        estado: { label: 'Activo', value: 1 },
        nombre: this.clienteSelect?.nombre ?? this.clienteSelect,
        tipo_cliente: this.clienteSelect?.tipo_cliente ?? 0
      }
    },
    activarClienteFactura() {
      const textoEscrito = this.nitClienteSelect?.trim() || ''
      const esNumerico = /^\d+$/.test(textoEscrito)

      this.cliente_factura = {
        estado: { label: 'Activo', value: 1 },
        ci_nit: esNumerico ? textoEscrito : '',
        nombre: !esNumerico ? textoEscrito : '', //
        tipo_documento: esNumerico ? (textoEscrito.length >= 9 ? 5 : 1) : 1
      }

      this.clienteFacturaModal = true
    },
    cerrarModalClienteFactura() {
      this.clienteFacturaModal = false
    },

    cerrarModalCliente() {
      this.clienteModal = false
      this.cliente = {}
    },
    guardandoCambiosCelda(e) {
      let { data, newValue, field } = e
      data[field] = newValue

      if (field == 'cantidad_venta') {
        if (!this.permitir_stock_negativo && data.cantidad_venta > data.cantidad) {
          data.cantidad_venta = null
          this.$toast.add({
            severity: 'error',
            summary: 'REVISAR STOCK DE PRODUCTO',
            detail: 'No hay suficiente stock: ' + data.nombre_producto,
            life: 60000
          })
        } else {
          data['total'] = data['cantidad_venta'] * data['ultimo_precio'] ?? 0
          this.calcular_subtotal()
          if (this.aplica_descuento) {
            this.calcular_agregar_des_total_venta_porcentaje()
          }
        }
      }

      if (field == 'ultimo_precio' && data['cantidad_venta'] > 0) {
        data['ultimo_precio'] = data['ultimo_precio'] ?? 0
        data['total'] = data['cantidad_venta'] * data['ultimo_precio']
        this.calcular_subtotal()
        if (this.aplica_descuento) {
          this.calcular_agregar_des_total_venta_porcentaje()
        }
      }

      if (field == 'descuento_neto' && data['cantidad_venta'] > 0) {
        if (newValue > data['total']) {
          data['descuento_neto'] = data['total']
          data['descuento_porcentaje'] = (data['descuento_neto'] * 100) / data['total'] /* .toFixed(2) */
          this.calcular_descuentos_totales_venta()
          this.$toast.add({
            severity: 'error',
            summary: 'REVISAR DESCUENTO',
            detail: 'El descuento no puede ser mayor al total',
            life: 60000
          })
          return
        }
        data['descuento_porcentaje'] = (newValue * 100) / data['total'] /* .toFixed(2) */
        this.calcular_descuentos_totales_venta()
      }
      if (field == 'descuento_porcentaje' && data['cantidad_venta'] > 0) {
        data['descuento_neto'] = (newValue * data['total']) / 100
        this.calcular_descuentos_totales_venta()
      }

      //Drowdon del medico
      if (field == 'medico_id') {
        const medico = this.medicos.find((med) => med.id === newValue)
        if (medico) {
          data['nombre_medico'] = medico.nombre_completo
        } else {
          data['nombre_medico'] = null
        }
      }
    },
    calcular_descuentos_totales_venta() {
      let desc_venta_neto = 0
      /* let desc_venta_porcentaje = 0; */
      this.productosVentas.forEach((producto) => {
        desc_venta_neto += producto.descuento_neto
        /* desc_venta_porcentaje += producto.descuento_porcentaje; */
      })
      this.descuento = desc_venta_neto
      /* this.desc_venta_porcentaje = desc_venta_porcentaje; */
      this.desc_venta_porcentaje = (this.descuento * 100) / this.subtotal
      this.calcular_total_venta()
    },
    calcular_subtotal() {
      this.subtotal = 0
      this.productosVentas.forEach((product) => {
        this.subtotal += product.total
      })
      this.total_venta = this.subtotal - this.descuento
      if (this.descuento >= 0) {
        this.agregar_descuento_detalle_productosventas()
      }
      this.calcular_interes_venta_a_credito()
    },
    agregar_descuento_detalle_productosventas() {
      if (this.productosVentas.length === 0) return

      let descuentoAcumulado = 0

      this.productosVentas.forEach((producto, index) => {
        // Si es el último producto, ajustar para que la suma sea exacta
        if (index === this.productosVentas.length - 1) {
          producto.descuento_neto = this.descuento - descuentoAcumulado
        } else {
          // Calcular descuento proporcional y redondear a 2 decimales
          producto.descuento_neto = Math.round(((this.descuento * producto.total) / this.subtotal) * 100) / 100
          descuentoAcumulado += producto.descuento_neto
        }
        // Calcular el porcentaje
        producto.descuento_porcentaje = producto.total > 0 ? (producto.descuento_neto * 100) / producto.total : 0
      })
    },
    calcular_total_venta() {
      this.total_venta = this.subtotal - this.descuento
      this.calcular_interes_venta_a_credito()
    },
    calcular_interes_venta_a_credito() {
      if (this.venta_credito) {
        this.venta_credito_saldo_debe = this.total_venta - this.a_cuenta - this.monto_pago
        this.monto_venta_a_credito_interes = this.venta_credito_saldo_debe * (this.interes_venta_a_credito / 100)
      }
    },
    calcular_descuento_venta_porcentaje() {
      // Redondear a 2 decimales
      this.desc_venta_porcentaje =
        this.subtotal > 0 ? Math.round(((this.descuento * 100) / this.subtotal) * 100) / 100 : 0
    },
    calcular_descuento_venta_neto() {
      // Redondear a 2 decimales
      this.descuento = Math.round(((this.desc_venta_porcentaje * this.subtotal) / 100) * 100) / 100
    },
    quitarProductoDetalle(datos) {
      this.$confirm.require({
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        message: '¿ESTÁS SEGURO DE ELIMINAR EL PRODUCTO?',
        acceptLabel: 'Si, Eliminar',
        rejectLabel: 'No, Cancelar',
        acceptClass: 'p-button-primary p-button-lg',
        rejectClass: 'p-button-danger p-button-lg',
        acceptIcon: 'pi pi-save',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.productosVentas.splice(datos.index, 1)

          if (this.productosVentas.length == 0 && this.venta_credito) {
            this.venta_credito = false
          }

          this.calcular_subtotal()
          this.calcular_agregar_des_total_venta_porcentaje()
        }
      })
    },
    buscarProductoPorCodigoBarra() {
      let datos = {
        texto: this.codigo_barra,
        sucursal_id: this.sucursal_id
      }
      this.productService.buscarXCodigoBarra(datos).then((response) => {
        if (response.productos.length == 0) {
          this.$toast.add({
            severity: 'info',
            summary: 'Producto',
            detail: 'No se encontraron productos',
            life: 2000
          })

          return
        }
        this.productosListadoFiltrado = [...response.productos]
        //preparo la data para enviar a agregar detalle venta

        this.agregarProductos(response.productos)
      })
    },
    /* buscarProducto() {
      let datos = {
        texto: this.productoSelecionado,
        buscarProductoPorSelected: this.buscarProductoPorSelected,
        sucursal_id: this.sucursal_id,
        grupo_id: this.grupoSelected,
        laboratorio_id: this.laboratorioSelected,
        caso_uso: this.caso_uso,
      };
      this.productService
        .buscarXNombreVenta(datos)
        .then((response) => {
          if (response.productos.length == 0) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "No se encontraron productos",
              life: 3000,
            });
            this.productosListadoFiltrado = [];
            return;
          }
          this.productosListadoFiltrado = [...response.productos];
          if (response.productos.length > 0) {
            this.productosListadoFiltrado.forEach((producto) => {
              if (
                "Venta Membresia" in this.auth.user.permissions &&
                this.tiene_membresia_activa
              ) {
                this.membresias_activas.forEach((membresia) => {
                  if (producto.descripcion == membresia.nombre_producto) {
                    producto.stock[0].ultimo_precio = 0;
                    producto.es_con_membresia = true;
                  }
                });
              }
            });
          }
          if (this.permisoActivarModalProductos) {
            this.activarModalProductosFiltrados();
          }
        })
        .catch((error) => console.log(error));
    }, */

    async cargarClientesListado(clienteNuevo = null) {
      try {
        if (clienteNuevo) {
          // Si viene un cliente nuevo, solo actualizar ese
          this.clienteSelect = clienteNuevo

          // Limpiar búsquedas previas
          this.clientes = []

          // Actualizar campos si no está facturando
          if (!this.facturar) {
            this.nit = clienteNuevo.ci_nit
            this.razon_social = clienteNuevo.nombre
          }

          return
        }

        // Si no hay cliente nuevo, cargar la lista completa
        const response = await this.clienteService.getClientesAll()
        this.clientes = response.data || response
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo cargar la lista de pacientes: ' + error.message,
          life: 3000
        })
      }
    },

    cargarVehiculos(vehiculo = null) {
      this.cerrarModalVehiculo()

      if (vehiculo) {
        let datos = {
          cliente_id: vehiculo.cliente_id,
          nombre: vehiculo.nombre_cliente,
          ci_nit: vehiculo.ci_nit,
          placa: vehiculo.placa,
          marca: vehiculo.marca_texto,
          modelo: vehiculo.modelo_texto,
          vehiculo_id: vehiculo.id
        }

        this.clienteSelect = datos
        this.ci_nit = vehiculo.ci_nit
        this.nombre_cliente = vehiculo.nombre_cliente
      }
    },
    cargarMedicosListado(medico = null) {
      this.medicoService.getMedicosAll().then((response) => {
        this.medicos = response.medicos
        if (medico) {
          this.medicos.forEach((element) => {
            if (element.id == medico.id) {
              this.medicoSelected = element.id
            }
          })
        }
      })
    },
    agregarDetalleVenta(data) {
      // 1. Verificar si ya existe el producto en el array
      let existe = this.productosVentas.find((producto) => producto.id == data.id)

      // 2. Si existe, aumentamos la cantidad y recalculamos
      if (existe) {
        // Solo validar si NO está permitido stock negativo
        if (!this.permitir_stock_negativo && data.tipo_catalogo == 1 && existe.cantidad_venta + 1 > data.cantidad) {
          this.$toast.add({
            severity: 'error',
            summary: 'Stock insuficiente',
            detail: 'No puedes agregar más cantidad de la disponible.',
            life: 3000
          })
          return
        }

        // Aumentar cantidad
        existe.cantidad_venta += 1 // O la cantidad que desees sumar

        // Recalcular el total de esa línea (cantidad * precio)
        existe.total = existe.ultimo_precio * existe.cantidad_venta

        // Limpiar selección y recalcular el total general de la venta
        this.productoSelecionado = null
        this.calcular_subtotal()

        this.$toast.add({
          severity: 'success',
          summary: 'Actualizado',
          detail: 'Se agregó una unidad más al producto.',
          life: 1000 // Corta duración para no molestar
        })

        return // Terminamos aquí para no volver a agregarlo abajo
      }

      // Validar precio
      /* if (data.ultimo_precio == 0 && data.tipo_catalogo == 1) {
        this.$toast.add({
          severity: "info",
          summary: "Venta",
          detail:
            "El producto no tiene un precio asignado: " + data.nombre_producto,
          life: 60000,
        });
        return;
      } */

      // Validar Stock solo si NO está permitido el stock negativo
      if (!this.permitir_stock_negativo && data.cantidad == 0 && data.tipo_catalogo == 1) {
        this.$toast.add({
          severity: 'error',
          summary: 'Sin Stock',
          detail: 'El producto: ' + data.nombre_producto + ' no tiene stock',
          life: 60000
        })
        this.productoSelecionado = null
        return
      }

      // 3. Si no existe, lo agregamos como nuevo
      let precio = data.ultimo_precio ?? data.precio_sugerido

      this.productosVentas.push({
        // Inicializar en 1 en lugar de null para evitar errores matemáticos
        cantidad_venta: 1,
        descuento_neto: 0,
        descuento_porcentaje: 0,
        ...data,
        ultimo_precio: precio,
        total: precio * 1, // Total inicial
        es_con_membresia: data.es_con_membresia,
        medico_id: data.medico_id ?? null,
        nombre_medico: data.nombre_medico ?? null,
        es_comisionable: data.es_comisionable ?? 0
      })

      // Limpieza final
      this.stockSucursales = []
      this.productosListadoFiltrado = []
      this.productoSelecionado = null

      this.calcular_subtotal()
    },
    agregarProductos(productosSeleccionados) {
      productosSeleccionados.forEach((producto) => {
        try {
          if (producto.stock == null || producto.stock == '' || producto.stock == 0) {
            this.$toast.add({
              severity: 'info',
              summary: 'VENTA/STOCK',
              detail: 'El producto: ' + producto.descripcion + ' no tiene stock',
              life: 60000
            })
            return
          }
          //let precio = producto.precio_sugerido ?? producto.ultimo_precio;
          let precio = this.obtenerPrecioSugerido2(producto, this.clienteSelect.tipo_cliente)
          let es_con_membresia = false
          let aumentar_cantidad_membresia = false
          if ('Venta Membresia' in this.auth.user.permissions && this.tiene_membresia_activa) {
            this.membresias_activas.forEach((membresia) => {
              //busco que los nombres de los productos no sean iguales a los nombres de las membresias
              if (producto.descripcion == membresia.nombre_producto) {
                precio = 0
                es_con_membresia = true
                aumentar_cantidad_membresia = true
              }
            })
          }

          this.agregarDetalleVenta({
            ...producto,
            cantidad: producto.stock[0].cantidad,
            producto_id: producto.id,
            sucursal_id: producto.stock[0].sucursal_id,
            nombre_producto: producto.descripcion,
            cantidad_venta: 1,
            descuento_neto: 0,
            descuento_porcentaje: 0,
            ultimo_precio: parseFloat(precio),
            precio_sugerido: parseFloat(precio),
            total: parseFloat(precio * 1),
            lote: producto.stock[0].lote ?? null,
            fecha_vence: producto.stock[0].fecha_vence ?? null,
            es_con_membresia: es_con_membresia,
            aumentar_cantidad_membresia: aumentar_cantidad_membresia,
            medico_id: producto.medico_id ?? null,
            nombre_medico: producto.nombre_medico ?? null,
            es_comisionable: producto.stock[0].es_comisionable ?? 0
          })
          this.calcular_subtotal()
          this.codigo_barra = null
        } catch (error) {
          console.log(error)
        }
      })

      this.cerrarModalProductoResultados()
    },
    agregarProductosPaqueteAlDetalle() {
      let datos = {
        paquete_producto_id: this.paqueteSelected
      }
      this.paqueteProductoService
        .getPaqueteProductoById(datos)
        .then((response) => {
          /* this.paqueteSelected = null; */
          response.paqueteproductosListado.forEach((producto) => {
            let paquete_cantidad = producto.cantidad
            let precio =
              producto.stock_para_caja_activa == null
                ? producto.producto.precio_sugerido
                : producto.stock_para_caja_activa.ultimo_precio
            //comparo la cantidad del stock con la cantidad del paquete
            if (producto.stock_para_caja_activa.cantidad < paquete_cantidad) {
              this.$toast.add({
                severity: 'error',
                summary: 'Revisar stock del producto',
                detail: 'El producto no tiene stock suficiente: ' + producto.producto.descripcion,
                life: 60000
              })
              return
            }
            this.agregarDetalleVenta({
              ...producto,
              id: producto.producto_id,
              cantidad: producto.stock_actual,
              sucursal_id: producto.sucursal_id,
              cantidad_venta: paquete_cantidad,
              descuento_neto: 0,
              descuento_porcentaje: 0,
              ultimo_precio: parseFloat(precio),
              precio_sugerido: parseFloat(producto.producto.precio_sugerido),
              total: parseFloat(precio * producto.cantidad),
              es_comisionable: producto.stock_para_caja_activa?.es_comisionable ?? 0
            })
            /* this.productosVentas.push(); */

            this.calcular_subtotal()
          })
        })
        .catch((error) => console.log(error))
    },
    agregarProductosProforma() {
      let datos = {
        proforma_codigo: this.proforma_codigo
      }

      this.ventaService.buscarProforma(datos).then((response) => {
        if (response.proforma != null) {
          this.cargandoProforma = true
          this.vieneDeProforma = true

          this.proforma_id = response.proforma.id

          this.observacion = response.proforma.observaciones || ''
          if (this.observacion) {
            this.observacion_check = true
          }

          let datos_cliente = {
            nombre_tipo_cliente: response.proforma.nombre_tipo_cliente,
            ci_nit: response.proforma.ci_nit,
            razon_social: response.proforma.cliente,
            cliente_id: response.proforma.cliente_id,
            nombre: response.proforma.cliente,
            id: response.proforma.cliente_id,
            tipo_cliente_id: response.proforma.tipo_cliente_id,
            tipo_cliente: response.proforma.tipo_cliente_id
          }

          if (response.proforma.tipo_negocio == 2) {
            datos_cliente.placa = response.proforma.placa_vehiculo
            datos_cliente.marca = response.proforma.marca_nombre
            datos_cliente.modelo = response.proforma.modelo_nombre
            datos_cliente.vehiculo_id = response.proforma.vehiculo_id
          }

          this.clienteSelect = datos_cliente

          if (response.proforma.medico_id) {
            this.medico_referencia = true
            this.medicoSelected = response.proforma.medico_id
          }

          let productosSinStock = 0
          let descuentoTotalProforma = 0

          response.proforma.detalles.forEach((producto) => {
            let precioProforma = parseFloat(producto.pivot.precio)
            let descuentoNeto = parseFloat(producto.pivot.descuento_neto || 0)
            let descuentoPorcentaje = parseFloat(producto.pivot.descuento_porcentaje || 0)
            let cantidadSolicitada = parseFloat(producto.pivot.cantidad)

            descuentoTotalProforma += descuentoNeto

            if (
              producto.tipo_catalogo == 1 &&
              (producto.stock_actual_new <= 0 || cantidadSolicitada > producto.stock_actual_new)
            ) {
              productosSinStock++
            }

            this.productosVentas.push({
              id: producto.pivot.producto_id,
              producto_id: producto.pivot.producto_id,
              nombre_producto: producto.descripcion,
              tipo_catalogo: producto.tipo_catalogo,
              cantidad: producto.stock_actual_new,
              cantidad_venta: cantidadSolicitada,
              descuento_neto: descuentoNeto,
              descuento_porcentaje: descuentoPorcentaje,
              ultimo_precio: precioProforma,
              precio_sugerido: precioProforma,
              total: precioProforma * cantidadSolicitada,
              lote: producto.pivot.lote ?? null,
              fecha_vence: producto.pivot.fecha_vence ?? null,
              es_comisionable: producto.es_comisionable ?? 0,
              comision_medico: producto.comision_medico ?? 0,
              medico_id: this.ver_medico_detalle
                ? producto.pivot.medico_id ?? response.proforma.medico_id ?? null
                : this.medicoSelected ?? null,

              nombre_medico: this.ver_medico_detalle
                ? producto.pivot.nombre_medico ?? response.proforma.nombre_medico ?? null
                : this.medicos.find((m) => m.id === this.medicoSelected)?.nombre_completo ?? null,
              //medico_id: producto.pivot.medico_id ?? response.proforma.medico_id ?? null,
              //nombre_medico: producto.pivot.nombre_medico ?? response.proforma.nombre_medico ?? null,
              fabrica_nombre: producto.fabrica_nombre ?? null,
              codigo_interno: producto.codigo_interno ?? null
            })
          })

          this.subtotal = 0
          this.productosVentas.forEach((product) => {
            this.subtotal += product.total
          })

          if (descuentoTotalProforma > 0) {
            this.aplica_descuento = true
            this.descuento = descuentoTotalProforma
            this.desc_venta_porcentaje = (descuentoTotalProforma * 100) / this.subtotal
          }

          this.total_venta = this.subtotal - this.descuento

          setTimeout(() => {
            this.cargandoProforma = false
          }, 100)

          if (productosSinStock > 0) {
            this.$toast.add({
              severity: 'error',
              summary: '⚠️ PRODUCTOS SIN STOCK',
              detail: `Hay ${productosSinStock} producto(s) SIN STOCK marcados en ROJO PARPADEANTE. DEBES QUITARLOS antes de guardar.`,
              life: 15000
            })
          }

          this.$toast.add({
            severity: 'success',
            summary: 'Proforma Cargada',
            detail: 'Productos agregados correctamente',
            life: 3000
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Proforma',
            detail: 'No se encontró la proforma',
            life: 60000
          })
        }
      })
    },
    formatDate(fecha) {
      if (!fecha) return ''
      let fecha_array = fecha.split('-')
      return `${fecha_array[2]}/${fecha_array[1]}/${fecha_array[0]}`
    },
    obtenerPrecioSugerido(producto, tipo_cliente) {
      let precio_sugerido = producto.ultimo_precio == 0 ? producto.precio_venta : producto.ultimo_precio
      if (tipo_cliente == 1) {
        // Mayorista
        precio_sugerido = producto.pv2 > 0 ? producto.pv2 : precio_sugerido
      }

      return parseFloat(precio_sugerido)
    },
    obtenerPrecioSugerido2(producto, tipo_cliente) {
      let precio_sugerido = producto.precio_sugerido
      if (tipo_cliente == 1) {
        // cliente pv2
        precio_sugerido = producto.stock[0].pv2 > 0 ? producto.stock[0].pv2 : precio_sugerido
      }
      return parseFloat(precio_sugerido)
    }
  },
  watch: {
    interes_venta_a_credito() {
      this.monto_venta_a_credito_interes = this.venta_credito_saldo_debe * (this.interes_venta_a_credito / 100)
    },
    venta_credito() {
      if (this.venta_credito == true) {
        this.tipo_pagoSelect = 2
        this.metodo_pagoSelect = 2
        this.a_cuenta = 0
        this.monto_pago = 0
        this.dias_credito = 0
        this.efectivo = 0
        this.venta_credito_saldo_debe = this.total_venta
      } else {
        this.tipo_pagoSelect = 1
        this.metodo_pagoSelect = 1
        this.a_cuenta = 0
        this.monto_pago = 0
        this.dias_credito = 0
        this.efectivo = this.total_venta
        this.venta_credito_saldo_debe = 0
      }
    },
    clienteSelect(newVal, oldVal) {
      // NUEVO: Limpiar lista cuando se borra el input
      if (oldVal && typeof oldVal === 'object' && (!newVal || newVal === '')) {
        this.clientes = []
        this.cacheBusquedaCliente.clear() // Limpiar todo el caché
      }

      // Código existente
      const datos = newVal
      if (!datos) return

      if (this.facturar) {
        this.nit = datos.ci_nit
        this.razon_social = datos.nombre
        this.nitClienteSelect = datos.ci_nit
        this.grupos_id_selected = datos.grupos_id_selected != null ? datos.grupos_id_selected.join(',\n') : null
        this.tiene_membresia_activa = datos.tiene_membresia_activa
        this.membresias_activas = datos.membresias_activas
        this.fecha_membresia_hasta = datos.fecha_membresia_hasta
      } else {
        this.nit = datos.ci_nit
        this.razon_social = datos.nombre
        this.grupos_id_selected = datos.grupos_id_selected != null ? datos.grupos_id_selected.join(',\n') : null
        this.tiene_membresia_activa = datos.tiene_membresia_activa
        this.membresias_activas = datos.membresias_activas
        this.fecha_membresia_hasta = datos.fecha_membresia_hasta
      }
    },
    productoSelecionado(newVal) {
      if (newVal != null) {
        if (newVal.id) {
          //this.productosVentas.push(newVal);

          this.stockSucursales = []
          let precio_sugerido = this.obtenerPrecioSugerido(
            newVal.stock[0],
            this.clienteSelect ? this.clienteSelect.tipo_cliente : 0
          )
          newVal.stock.forEach((producto) => {
            /* let precio_sugerido =
              producto.ultimo_precio == 0
                ? newVal.precio_sugerido
                : producto.ultimo_precio; */

            let es_con_membresia = false
            let aumentar_cantidad_membresia = false
            if ('Venta Membresia' in this.auth.user.permissions && this.tiene_membresia_activa) {
              this.membresias_activas.forEach((membresia) => {
                //busco que los nombres de los productos no sean iguales a los nombres de las membresias
                if (newVal.descripcion == membresia.nombre_producto) {
                  precio_sugerido = 0
                  es_con_membresia = true
                  aumentar_cantidad_membresia = true
                }
              })
            }

            this.stockSucursales.push({
              ...producto,
              ultimo_precio: parseFloat(precio_sugerido ?? 0),
              cantidad_venta: 1,
              descuento_neto: 0,
              descuento_porcentaje: 0,
              es_con_membresia: es_con_membresia,
              aumentar_cantidad_membresia: aumentar_cantidad_membresia,
              es_comisionable: producto.es_comisionable ?? 0
            })
            // automaticamente selecciono la producto con el menor id y llamo a mi funcion agregarDetalleVenta
            if (producto.id == this.stockSucursales[0].id) {
              this.agregarDetalleVenta(this.stockSucursales[0])
            }
          })
        }
      }
    },
    total_venta() {
      if (this.venta_credito) {
        this.venta_credito_saldo_debe = this.total_venta - this.a_cuenta
      }
      if (this.tipo_pagoSelect == 1) {
        this.efectivo = this.total_venta
      } else {
        this.a_cuenta = this.a_cuenta > 0 ? this.a_cuenta : 0
        this.efectivo = 0
      }
      if (this.metodo_pagoSelect == 1) {
        this.monto_pago = 0
      } else {
        this.monto_pago = this.total_venta
      }
    },
    a_cuenta() {
      if (this.a_cuenta > this.total_venta) {
        this.$toast.add({
          severity: 'info',
          summary: 'Venta',
          detail: 'El monto a cuenta no puede ser mayor al total de la venta',
          life: 60000
        })
        this.a_cuenta = 0
        return
      }
      if (this.venta_credito) {
        this.venta_credito_saldo_debe = this.total_venta - this.a_cuenta
        this.calcular_interes_venta_a_credito()
        return
      }
      this.efectivo = this.a_cuenta
    },
    monto_pago() {
      if (this.venta_credito) {
        this.venta_credito_saldo_debe = this.total_venta - this.monto_pago
        this.calcular_interes_venta_a_credito()
        return
      }

      if (this.tipo_pagoSelect == 2) {
        this.efectivo = this.a_cuenta - this.monto_pago
      } else {
        this.efectivo = this.total_venta - this.monto_pago
      }
    },
    tipo_pagoSelect() {
      if (this.tipo_pagoSelect == 1) {
        this.a_cuenta = 0
        this.monto_pago = 0
        this.dias_credito = 0
        this.efectivo = this.total_venta
        this.a_credito_check = ''
      } else {
        this.dias_credito = 30
        this.interes_venta_a_credito = 0
        this.a_cuenta = 0
        this.metodo_pagoSelect = 1
        this.monto_pago = 0
        this.efectivo = this.a_cuenta
      }
    },
    metodo_pagoSelect() {
      if (this.metodo_pagoSelect == 1) {
        this.monto_pago = 0
        this.efectivo = this.total_venta - this.a_cuenta
        this.metodo_pago_check = ''
        this.nro_tarjeta = null
      } else if (this.metodo_pagoSelect == 2 && this.a_credito_check == 'a_credito_check') {
        this.monto_pago = 0
        this.efectivo = 0
      } else {
        this.efectivo = 0
        this.monto_pago = this.total_venta - this.efectivo
      }
    },
    metodo_pago_check() {
      if (this.metodo_pago_check == 'metodo_pago_check') {
        this.metodo_pagoSelect = 6
        this.efectivo = 0
        this.monto_pago = this.total_venta - this.efectivo
      } else if (this.metodo_pago_check == 'metodo_pago_check' && this.a_credito_check == 'a_credito_check') {
        this.efectivo = 0
        this.monto_pago = 0
      } else {
        this.metodo_pagoSelect = 1
        this.metodo_pago_check = ''
        this.monto_pago = 0
        this.efectivo = this.total_venta - this.a_cuenta
      }
    },
    a_credito_check() {
      if (this.a_credito_check == 'a_credito_check') {
        this.tipo_pagoSelect = 2
        this.dias_credito = 30
        this.a_cuenta = 0
        this.metodo_pagoSelect = 1
        this.monto_pago = 0
        this.efectivo = this.a_cuenta
      } else {
        this.tipo_pagoSelect = 1
        this.a_credito_check = ''
        this.a_cuenta = 0
        this.dias_credito = 0
        this.efectivo = this.total_venta
      }
    },
    /* aplica_descuento() {
      if (this.aplica_descuento == "aplica_descuento") {
        this.desc_venta_porcentaje = 0;
        this.calcular_agregar_des_total_venta_porcentaje();
      } else {
        this.desc_venta_porcentaje = 0;
      }
    }, */

    aplica_descuento() {
      if (this.aplica_descuento) {
        if (!this.cargandoProforma) {
          this.desc_venta_porcentaje = 0
          this.calcular_agregar_des_total_venta_porcentaje()
        }
      } else {
        this.desc_venta_porcentaje = 0
      }
    },
    facturar(nuevoValor, valorAnterior) {
      // Si se ACTIVA facturar (false → true): SIEMPRE cargar datos
      if (nuevoValor && !valorAnterior) {
        if (this.clienteSelect) {
          const ciNit = this.clienteSelect.ci_nit || this.clienteSelect.nit || ''
          const nombre = this.clienteSelect.nombre || this.clienteSelect.razon_social || ''

          this.nit = ciNit
          this.razon_social = nombre
          this.nitClienteSelect = ciNit

          this.buscarClientePorNitImpl(ciNit)
        }
        return
      }

      // Si se DESACTIVA facturar (true → false)
      if (!nuevoValor && valorAnterior) {
        // Solo limpiar si NO está registrar_para_facturacion
        if (this.registrar_para_facturacion) {
          return
        }

        this.nit = ''
        this.razon_social = ''
        this.nitClienteSelect = null
      }
    },
    medico_referencia(val) {
      if (!val) {
        this.medicoSelected = null // limpia si desmarca
      }
    },
    proforma(val) {
      if (val) {
        this.medico_referencia = false
        this.medicoSelected = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.p-invalid {
  color: red;
}

::v-deep(.editable-cells-table td.p-cell-editing) {
  padding-top: 0;
  padding-bottom: 0;
}

.outofstock {
  font-weight: 700;
  color: #ffffff;
  background-color: rgb(244, 67, 54);
  padding: 2px 8px;
  border-radius: 4px;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 2px 8px;
  border-radius: 4px;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 2px 8px;
  border-radius: 4px;
}

.p-fondo {
  background-color: #6abad0;
  border-radius: 0.5em;
  border: 1px solid #002236;
}

.precio {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.p-inputgroup-addon {
  background-color: #ffffff;
  font-weight: bold;
  color: #000000;
  border: none;
}

.estiloBoton {
  background-color: #002236;
  color: #ffffff;
  border: none;
  border-radius: 0.5em;
  font-weight: bold;
  transition: background-color 0.3s, color 0.3s;
}

.estiloBoton:not(.activo) {
  background-color: #d0d0d0;
  color: #333333;
}

.estiloBoton.activo {
  background-color: #004080;
  color: #ffffff;
}

.estiloBoton:hover {
  background-color: #003366;
  color: #ffffff;
}

.estiloBoton:not(.activo):hover {
  background-color: #b0b0b0;
  color: #333333;
}

.modal-facturacion {
  ::v-deep(.p-dialog-header) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 1.5rem;

    .p-dialog-title {
      font-weight: bold;
      font-size: 1.2rem;
    }
  }

  ::v-deep(.p-dialog-content) {
    padding: 2rem;
  }
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
}

.loading-info {
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  width: 100%;
}

.warning-box {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 0.5rem;
  margin-top: 1rem;
}

.p-button-danger.p-button-sm {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  }
}

.nit-numero-destacado {
  font-size: 1.3rem;
  font-weight: 900;
  color: #2c3e50;
  display: inline-block;
  transition: all 0.2s ease-in-out;
  padding: 0 4px;
}

.nit-numero-destacado:hover {
  transform: scale(1.4);
  color: #ffffff;
  background-color: #002236;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.7);
  cursor: default;
}

.mobile-label {
  display: none;
}

/* DESKTOP - Sistema de columnas que llena todo el ancho */
.flex.align-options-center {
  display: flex;
  width: 100%;
}

.flex.align-options-center .col-1 {
  width: 8.333333%;
  flex-shrink: 0;
}

.flex.align-options-center .col-2 {
  width: 16.666667%;
  flex-shrink: 0;
}

.flex.align-options-center .col-5 {
  width: 41.666667%;
  flex-shrink: 0;
}

.flex.align-options-center .col-7 {
  flex: 1;
  min-width: 0;
}

.flex.align-options-center .col-producto .producto-nombre {
  font-weight: 400;
  color: #1a1a1a;
}

.flex.align-options-center .col-marca {
  font-weight: 600;
  color: #444;
}

/* Precio ocupa el espacio restante */
.flex.align-options-center .col-precio {
  flex: 0 0 auto;
  min-width: 80px;
  padding: 0 4px !important;
}

.flex.align-options-center .col-precio strong {
  padding: 3px 8px;
  display: inline-block;
  width: 100%;
  text-align: center;
}

/* Stock compacto */
.flex.align-options-center .col-stock {
  flex: 0 0 auto;
  min-width: 50px;
  padding: 0 4px !important;
}

.flex.align-options-center .col-stock strong {
  padding: 3px 8px;
  display: inline-block;
  width: 100%;
  text-align: center;
}

/* Filas con fondo alternado */
.tabla-fila {
  background-color: #ffffff;
}

.tabla-fila:nth-child(even) {
  background-color: #fafafa;
}

.tabla-fila:hover {
  background: linear-gradient(to right, #e3f2fd 0%, #bbdefb 100%);
  transform: translateX(2px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

/* Ocultar "Bs." en mobile, mostrar solo en desktop */
.desktop-only {
  display: inline;
}

/* Marca en mobile - oculta por defecto */
.producto-marca-mobile {
  display: none;
}

/* RESPONSIVE - MOBILE */
@media screen and (max-width: 768px) {
  /* Ocultar "Bs." en mobile */
  .desktop-only {
    display: none !important;
  }

  /* Mostrar marca en mobile con fondo plomito */
  .producto-marca-mobile {
    display: inline !important;
    font-size: 0.9rem !important;
    font-weight: 600 !important;
    color: #444 !important;
    background-color: #d3d3d3 !important;
    padding: 2px 6px !important;
    border-radius: 3px !important;
    margin-left: 4px !important;
  }

  .flex.align-options-center {
    display: grid !important;
    grid-template-columns: 1fr auto auto !important;
    grid-template-rows: auto !important;
    gap: 4px 4px !important;
    padding: 6px 4px !important;
    align-items: center !important;
  }

  /* Resetear anchos de columnas en mobile */
  .flex.align-options-center .col-1,
  .flex.align-options-center .col-2,
  .flex.align-options-center .col-5,
  .flex.align-options-center .col-7 {
    width: auto !important;
    min-width: 0 !important;
    flex: none !important;
  }

  .flex.align-options-center .col-codigo {
    display: none !important;
  }

  /* PRODUCTO - 2 líneas */
  .flex.align-options-center .col-producto {
    grid-column: 1 / 2 !important;
    grid-row: 1 / 2 !important;
    font-size: 1rem !important;
    font-weight: 700 !important;
    line-height: 1.3 !important;
    white-space: normal !important;
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    padding: 0 4px 0 0 !important;
    margin: 0 !important;
    word-break: break-word !important;
  }

  .flex.align-options-center .col-producto .producto-nombre {
    font-size: 1rem !important;
    font-weight: 700 !important;
  }

  /* MARCA y CASO ocultos en mobile */
  .flex.align-options-center .col-marca,
  .flex.align-options-center .col-caso {
    display: none !important;
  }

  /* STOCK */
  .flex.align-options-center .col-stock {
    grid-column: 2 / 3 !important;
    grid-row: 1 / 2 !important;
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-shrink: 0 !important;
  }

  .flex.align-options-center .col-stock strong {
    font-size: 1rem !important;
    font-weight: 900 !important;
    padding: 5px 7px !important;
    margin: 0 !important;
    display: inline-block !important;
    text-align: center !important;
  }

  /* PRECIO */
  .flex.align-options-center .col-precio {
    grid-column: 3 / 4 !important;
    grid-row: 1 / 2 !important;
    padding: 0 !important;
    margin: 0 !important;
    background-color: transparent !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-shrink: 0 !important;
  }

  .flex.align-options-center .col-precio strong {
    font-size: 1rem !important;
    font-weight: 900 !important;
    padding: 5px 7px !important;
    margin: 0 !important;
    color: #ffffff !important;
    background-color: #f44336 !important;
    border-radius: 3px !important;
    display: inline-block !important;
    text-align: center !important;
    white-space: nowrap !important;
  }

  .instock,
  .lowstock,
  .outofstock {
    font-size: 1rem !important;
    padding: 5px 7px !important;
    border-radius: 3px !important;
    display: inline-block !important;
    text-align: center !important;
  }
}

/* Pantallas muy pequeñas */
@media screen and (max-width: 400px) {
  .flex.align-options-center {
    gap: 3px 3px !important;
    padding: 5px 3px !important;
  }

  .flex.align-options-center .col-producto {
    font-size: 0.95rem !important;
    padding: 0 3px 0 0 !important;
  }

  .flex.align-options-center .col-producto .producto-nombre {
    font-size: 0.95rem !important;
  }

  .producto-marca-mobile {
    font-size: 0.85rem !important;
    padding: 2px 5px !important;
  }

  .flex.align-options-center .col-stock strong,
  .flex.align-options-center .col-precio strong {
    font-size: 0.95rem !important;
    padding: 4px 6px !important;
  }

  .instock,
  .lowstock,
  .outofstock {
    font-size: 0.95rem !important;
    padding: 4px 6px !important;
  }
}
.membresia_activa {
  background-color: #008d0c;
  border-radius: 5px;
  padding: 3px;
  color: #fff;
}
.membresia_inactiva {
  background-color: #ff0015;
  border-radius: 5px;
  padding: 3px;
  color: #fff;
}
</style>
